<template></template>
<script>
import { Criteria } from "~/context/Shared/domain/criteria/Criteria";
import { Filter } from "~/context/Shared/domain/criteria/Filter";
import { Order } from "~/context/Shared/domain/criteria/Order";
import { DocumentDomain } from "~/context/Shared/domain/DocumentDomain";


export function returnBalanceToMovementFromReconciliation(movement, reconciliation) {
  let reconciliation_amount_assign =
    reconciliation.reconciliation_reference_amount -
    reconciliation.reconciliation_reference_balance;
  movement.movement_balance = movement.movement_balance + reconciliation_amount_assign;
  return movement;
}

export function transformReferenceToObject(recReference, recRefTemporalBalance) {
  // segundo transformar el objeto de reconciliacion a un objeto de invoice o al que corresponda.

  console.log("en transformReferenceToObject ");
  console.log("recReference: " + JSON.stringify(recReference));
  console.log("DocumentDomain.MOVEMENT: " + DocumentDomain.MOVEMENT);
  console.log(
    "recReference.reconciliation_reference_type: " +
    recReference.reconciliation_reference_type
  );
  console.log(
    "recReference: " +
    (recReference.reconciliation_reference_type === DocumentDomain.MOVEMENT)
  );

  let referenceAsObject = {};
  if (recReference.reconciliation_reference_type === DocumentDomain.INVOICE) {
    console.log("es un " + DocumentDomain.INVOICE);
    referenceAsObject = {
      uid: recReference.reconciliation_reference_object_uid,
      company_uid: recReference.reconciliation_reference_company_uid,
      invoice_number: recReference.reconciliation_reference_businessNumber,
      invoice_receiver_legal_id: recReference.reconciliation_reference_receiver_legal_id,
      invoice_sender_legal_id: recReference.reconciliation_reference_sender_legal_id,
      invoice_total_amount: recReference.reconciliation_reference_amount,
      invoice_net_amount: recReference.reconciliation_reference_net_amount,
      invoice_exempt_amount: recReference.reconciliation_reference_exempt_amount,
      invoice_tax_amount: recReference.reconciliation_reference_tax_amount,
      invoice_type: recReference.reconciliation_reference_type,
      invoice_balance: recReference.reconciliation_reference_balance,
      invoice_balance_currency: recReference.reconciliation_reference_balance_currency,
      invoice_number: recReference.reconciliation_reference_businessNumber,
      invoice_date: recReference.reconciliation_reference_date,
      invoice_reception_date: recReference.reconciliation_reference_reception_date,
      invoice_sender_name: recReference.reconciliation_reference_description,
      invoice_currency: recReference.reconciliation_reference_currency,
      invoice_original_type: recReference.reconciliation_reference_object_original_type,
      invoice_state: recReference.reconciliation_reference_state,
    };
  } else if (recReference.reconciliation_reference_type === DocumentDomain.MOVEMENT) {
    console.log("es un XX: " + DocumentDomain.MOVEMENT);
    referenceAsObject = {
      uid: recReference.reconciliation_reference_object_uid,
      account_uid: recReference.reconciliation_reference_account_uid,
      company_uid: recReference.reconciliation_reference_company_uid,
      movement_account_number: recReference.reconciliation_reference_account_number,
      movement_reference: recReference.reconciliation_reference_businessNumber,
      //TODO: revisar esto del balance
      movement_balance: recRefTemporalBalance,
      movement_balance_currency: recReference.reconciliation_reference_balance_currency,
      movement_total_amount: recReference.reconciliation_reference_amount,
      movement_date: recReference.reconciliation_reference_date,
      movement_transaction_date: recReference.reconciliation_reference_transaction_date,
      movement_description: recReference.reconciliation_reference_description,
      movement_currency: recReference.reconciliation_reference_currency,
      movement_type: DocumentDomain.MOVEMENT,
      movement_origin_id: recReference.reconciliation_reference_origin_id,
      movement_original_type: recReference.reconciliation_reference_object_original_type,
      movement_pending: recReference.reconciliation_reference_pending,
      movement_client_provider: recReference.reconciliation_reference_client_provider,
      movement_sender: recReference.reconciliation_reference_sender,
      movement_sender_legal_id: recReference.reconciliation_reference_sender_legal_id,
      movement_type_format: formatMovementType(
        DocumentDomain.MOVEMENT,
        recReference.reconciliation_reference_object_original_type,
        recReference.reconciliation_reference_amount
      ),
      //TODO: agregar la difference
    };
  } else {
    console.log("no es nada " + recReference.reconciliation_reference_type);
  }

  return referenceAsObject;
}

export function transformReconciliationToInvoice(reconciliation, assignAmount) {
  let reconAsInvoice = {};
  reconAsInvoice = {
    uid: reconciliation.reconciliation_reference_object_uid,
    invoice_number: reconciliation.reconciliation_reference_businessNumber,
    invoice_balance: reconciliation.reconciliation_reference_balance + assignAmount,
    invoice_total_amount: reconciliation.reconciliation_reference_amount,
    invoice_date: reconciliation.reconciliation_reference_date,
    invoice_sender_name: reconciliation.reconciliation_reference_description,
    invoice_currency: reconciliation.reconciliation_reference_currency,
    invoice_type: reconciliation.reconciliation_reference_type,
  };

  return reconAsInvoice;
}

export async function loadPageInvoiceWithDistance(
  companyId,
  movementId,
  pageNumber,
  pageSize
) {
  const defaultFilter = new Filter("company_uid", "=", companyId);

  let arrayFilters = [];
  arrayFilters.push(defaultFilter);

  const criteria = new Criteria(pageNumber, pageSize, arrayFilters);

  const pageInvoice = await useInvoiceCompanyDistanceCriteria(
    companyId,
    movementId,
    criteria
  );
  return pageInvoice;
}

export async function loadPageDocumentWithDistance(
  companyId,
  movement,
  pageNumber,
  pageSize
) {

  const defaultFilter = new Filter("company_uid", "=", companyId);

  const balanceFilter = new Filter("document_balance", ">", 0);

  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  arrayFilters.push(balanceFilter);

  const criteria = new Criteria(pageNumber, pageSize, arrayFilters);

  const pageDocument = await useDocumentCompanyDistanceCriteriaWithMovement(
    companyId,
    movement,
    criteria
  );
  return pageDocument;
}

export async function loadPageMovementWithDistance(
  companyId,
  document,
  pageNumber,
  pageSize
) {
  //console.log("llamando loadPageMovementWithDistance:" + pageNumber + " / " + pageSize);
  //console.log("companyId: " + companyId);
  //console.log("document: " + JSON.stringify(document));
  const defaultFilter = new Filter("company_uid", "=", companyId);

  let arrayFilters = [];
  arrayFilters.push(defaultFilter);

  const criteria = new Criteria(pageNumber, pageSize, arrayFilters);

  //console.log("loadPageMovementWithDistance (document): " + JSON.stringify(document));
  if (document && document.movement_type === DocumentDomain.MOVEMENT) {
    const pageMovement = await useMovementCompanyDistanceCriteriaWithMovement(
      companyId,
      document,
      criteria
    );
    return pageMovement;
  } else if (
    document &&
    (document.document_type === DocumentDomain.INVOICE ||
      document.document_type === DocumentDomain.BILL ||
      document.document_type === DocumentDomain.EXPENSE)
  ) {
    const pageMovement = await useMovementCompanyDistanceCriteriaWithDocument(
      companyId,
      document,
      criteria
    );
    return pageMovement;
  }
}

export async function loadPageActiveMovementWithDistance(
  companyId,
  documentId,
  type,
  pageNumber,
  pageSize
) {
  const defaultFilter = new Filter("company_uid", "=", companyId);

  const active = new Filter("movement_balance", "!=", 0);

  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  arrayFilters.push(active);

  const criteria = new Criteria(pageNumber, pageSize, arrayFilters);
  console.log("loadPageActiveMovementWithDistance: " + JSON.stringify(criteria));
  const pageMovement = await useMovementCompanyDistanceCriteria(
    companyId,
    documentId,
    type,
    criteria
  );
  console.log("pageMovementX: " + JSON.stringify(pageMovement));
  return pageMovement;
}

export async function loadPageActiveOutcomeMovementWithDistance(
  companyId,
  documentId,
  type,
  pageNumber,
  pageSize
) {
  const defaultFilter = new Filter("company_uid", "=", companyId);
  const active = new Filter("movement_balance", "!=", 0);
  const outcome = new Filter("movement_amount", "<", 0);

  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  arrayFilters.push(active);
  arrayFilters.push(outcome);

  const criteria = new Criteria(pageNumber, pageSize, arrayFilters);

  console.log("loadPageActiveOutcomeMovementWithDistance: " + JSON.stringify(criteria));
  const pageMovement = await useMovementCompanyDistanceCriteria(
    companyId,
    documentId,
    type,
    criteria
  );
  console.log("pageMovement: " + JSON.stringify(pageMovement));
  return pageMovement;
}

export function addUniqueObjects(objectsNew, objectsOld) {
  const uids = new Set(objectsOld.map((object) => object.uid));

  for (let i = 0, len = objectsNew.length; i < len; i++) {
    if (!uids.has(objectsNew[i].uid)) {
      objectsOld.push(objectsNew[i]);
    } else {
      console.log("ya existe" + objectsNew[i].uid);
    }
  }
  return objectsOld;
}

export function sortObjects(field, order, objectsDB, pageNumber, pageSize) {
  let ascending = order === "asc";
  if (order === "desc") {
    ascending = false;
  }
  console.log(
    "field: " +
    field +
    " order: " +
    JSON.stringify(order) +
    " objectsDB: " +
    JSON.stringify(objectsDB.length) +
    " pageNumber: " +
    pageNumber +
    " pageSize: " +
    pageSize
  );
  //console.log(" objectsDB unorder -->: " + JSON.stringify(objectsDB));
  if (objectsDB?.length > 0) {
    objectsDB.sort((a, b) => {
      let valueA = a[field];
      let valueB = b[field];

      if (field.toString().includes("date")) {
        valueA = new Date(valueA);
        valueB = new Date(valueB);
      } else if (field.toString().endsWith("_amount")) {
        valueA = parseFloat(valueA);
        valueB = parseFloat(valueB);
      } else if (field.toString().endsWith("_balance")) {
        valueA = parseFloat(valueA);
        valueB = parseFloat(valueB);
      }

      if (typeof valueA === "number") {
        //console.log("number");
        return ascending ? valueA - valueB : valueB - valueA;
      }
      if (valueA instanceof Date) {
        //console.log("valueA: " + valueA.getTime() + " valueB: " + valueB.getTime());
        return ascending
          ? valueA.getTime() - valueB.getTime()
          : valueB.getTime() - valueA.getTime();
      }

      if (typeof valueA === "string") {
        //    console.log("string");
        return ascending ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }

      return 0;
    });

    const startIdx = (pageNumber - 1) * pageSize;
    const endIdx = startIdx + pageSize;
    //console.log(" objectsDB order: " + JSON.stringify(objectsDB))
    return objectsDB?.slice(startIdx, endIdx);
  } else {
    return objectsDB;
  }
}

export function sortObjectsFull(field, order, objectsDB) {
  let ascending = order === "asc";
  if (order === "desc") {
    ascending = false;
  }
  console.log(
    "field: " +
    field +
    " order: " +
    JSON.stringify(order) +
    " objectsDB: " +
    JSON.stringify(objectsDB?.length)
  );
  //console.log(" objectsDB unorder -->: " + JSON.stringify(objectsDB));
  if (objectsDB?.length > 0) {
    objectsDB.sort((a, b) => {
      let valueA = a[field];
      let valueB = b[field];

      if (field.toString().includes("date")) {
        valueA = new Date(valueA);
        valueB = new Date(valueB);
      } else if (field.toString().endsWith("_amount")) {
        valueA = parseFloat(valueA);
        valueB = parseFloat(valueB);
      } else if (field.toString().endsWith("_balance")) {
        valueA = parseFloat(valueA);
        valueB = parseFloat(valueB);
      }

      if (typeof valueA === "number") {
        //console.log("number");
        return ascending ? valueA - valueB : valueB - valueA;
      }
      if (valueA instanceof Date) {
        //console.log("valueA: " + valueA.getTime() + " valueB: " + valueB.getTime());
        return ascending
          ? valueA.getTime() - valueB.getTime()
          : valueB.getTime() - valueA.getTime();
      }

      if (typeof valueA === "string") {
        //    console.log("string");
        return ascending ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }

      return 0;
    });

    //    const startIdx = (pageNumber - 1) * pageSize;
    //   const endIdx = startIdx + pageSize;
    //console.log(" objectsDB order: " + JSON.stringify(objectsDB))
  }
  return objectsDB;
}

export function getReconciliationAndReference(
  reconciliation,
  reconciliationReference,
  fromObject,
  toObject
) {
  console.log("reconciliation: " + JSON.stringify(reconciliation));
  console.log("reference: " + JSON.stringify(reconciliationReference));
  console.log("fromObject: " + fromObject);
  console.log("toObject: " + toObject);
  console.log("--->" + (toObject && toObject == DocumentDomain.EXPENSE));
  let recTemporal = {};
  let recrefTemporal = {};
  if (fromObject && fromObject == DocumentDomain.MOVEMENT) {
    recTemporal = {
      reconciliation_object_uid: reconciliation.uid,
      reconciliation_account_uid: reconciliation.account_uid,
      reconciliation_company_uid: reconciliation.company_uid,
      reconciliation_account_number: reconciliation.movement_account_number,
      reconciliation_total_amount: parseFloat(reconciliation.movement_total_amount),
      reconciliation_type: reconciliation.movement_type,
      reconciliation_balance: reconciliation.movement_balance
        ? parseFloat(reconciliation.movement_balance)
        : parseFloat(reconciliation.movement_total_amount),
      reconciliation_balance_currency: reconciliation.movement_balance_currency,
      reconciliation_businessNumber: reconciliation.movement_reference,
      reconciliation_date: reconciliation.movement_date,
      reconciliation_transaction_date: reconciliation.movement_transaction_date,
      reconciliation_description: reconciliation.movement_description,
      reconciliation_currency: reconciliation.movement_currency,
      reconciliation_origin_id: reconciliation.movement_origin_id,
      reconciliation_original_type: reconciliation.movement_original_type,
      reconciliation_pending: reconciliation.movement_pending,
      reconciliation_client_provider: reconciliation.movement_client_provider,
    };
  }
  //TODO: cambiar document_sender po document_aditional_info
  else if (fromObject && fromObject == DocumentDomain.DOCUMENT) {
    recTemporal = {
      reconciliation_object_uid: reconciliation.uid,
      reconciliation_company_uid: reconciliation.company_uid,
      reconciliation_receiver_legal_id: reconciliation.document_receiver_legal_id,
      reconciliation_sender_legal_id: reconciliation.document_sender_legal_id,
      reconciliation_total_amount: parseFloat(reconciliation.document_total_amount),
      reconciliation_net_amount: parseFloat(reconciliation.document_net_amount),
      reconciliation_exempt_amount: parseFloat(reconciliation.document_exempt_amount),
      reconciliation_tax_amount: parseFloat(reconciliation.document_tax_amount),
      reconciliation_type: reconciliation.document_type,
      reconciliation_balance: reconciliation.document_balance
        ? parseFloat(reconciliation.document_balance)
        : parseFloat(reconciliation.document_total_amount),
      reconciliation_balance_currency: reconciliation.document_balance_currency,
      reconciliation_businessNumber: reconciliation.document_number,
      reconciliation_date: reconciliation.document_date,
      reconciliation_reception_date: reconciliation.document_reception_date,
      reconciliation_description: reconciliation.document_sender_name,
      reconciliation_currency: reconciliation.document_currency,
      reconcilation_state: reconciliation.document_state,
    };
  } else if (fromObject && fromObject == DocumentDomain.INVOICE) {
    recTemporal = {
      reconciliation_object_uid: reconciliation.uid,
      reconciliation_company_uid: reconciliation.company_uid,
      reconciliation_receiver_legal_id: reconciliation.invoice_receiver_legal_id,
      reconciliation_sender_legal_id: reconciliation.invoice_sender_legal_id,
      reconciliation_total_amount: parseFloat(reconciliation.invoice_total_amount),
      reconciliation_net_amount: parseFloat(reconciliation.invoice_net_amount),
      reconciliation_exempt_amount: parseFloat(reconciliation.invoice_exempt_amount),
      reconciliation_tax_amount: parseFloat(reconciliation.invoice_tax_amount),
      reconciliation_type: reconciliation.invoice_type,
      reconciliation_balance: reconciliation.invoice_balance
        ? parseFloat(reconciliation.invoice_balance)
        : parseFloat(reconciliation.document_total_amount),
      reconciliation_balance_currency: reconciliation.invoice_balance_currency,
      reconciliation_businessNumber: reconciliation.invoice_number,
      reconciliation_date: reconciliation.invoice_date,
      reconciliation_reception_date: reconciliation.invoice_reception_date,
      reconciliation_description: reconciliation.invoice_sender_name,
      reconciliation_currency: reconciliation.invoice_currency,
      reconcilation_state: reconciliation.invoice_state,
    };
  } else if (fromObject && fromObject == DocumentDomain.BILL) {
    recTemporal = {
      reconciliation_object_uid: reconciliation.uid,
      reconciliation_company_uid: reconciliation.company_uid,
      reconciliation_receiver_legal_id: reconciliation.bill_receiver_legal_id,
      reconciliation_sender_legal_id: reconciliation.bill_sender_legal_id,
      reconciliation_total_amount: parseFloat(reconciliation.bill_total_amount),
      reconciliation_net_amount: parseFloat(reconciliation.bill_net_amount),
      reconciliation_exempt_amount: parseFloat(reconciliation.bill_exempt_amount),
      reconciliation_tax_amount: parseFloat(reconciliation.bill_tax_amount),
      reconciliation_type: reconciliation.bill_type,
      reconciliation_balance: reconciliation.bill_balance
        ? parseFloat(reconciliation.bill_balance)
        : parseFloat(reconciliation.document_total_amount),
      reconciliation_balance_currency: reconciliation.bill_balance_currency,
      reconciliation_businessNumber: reconciliation.bill_number,
      reconciliation_date: reconciliation.bill_date,
      reconciliation_reception_date: reconciliation.bill_reception_date,
      reconciliation_description: reconciliation.bill_sender_name,
      reconciliation_currency: reconciliation.bill_currency,
      reconcilation_state: reconciliation.bill_state,
    };
  } else if (fromObject && fromObject == DocumentDomain.EXPENSE) {
    recTemporal = {
      reconciliation_object_uid: reconciliation.uid,
      reconciliation_company_uid: reconciliation.company_uid,
      reconciliation_receiver_legal_id: reconciliation.expense_receiver_legal_id,
      reconciliation_sender_legal_id: reconciliation.expense_sender_legal_id,
      reconciliation_total_amount: parseFloat(reconciliation.expense_total_amount),
      reconciliation_net_amount: parseFloat(reconciliation.expense_net_amount),
      reconciliation_exempt_amount: parseFloat(reconciliation.expense_exempt_amount),
      reconciliation_tax_amount: parseFloat(reconciliation.expense_tax_amount),
      reconciliation_type: reconciliation.expense_type,
      reconciliation_balance: reconciliation.expense_balance
        ? parseFloat(reconciliation.expense_balance)
        : parseFloat(reconciliation.document_total_amount),
      reconciliation_balance_currency: reconciliation.expense_balance_currency,
      reconciliation_businessNumber: reconciliation.expense_number,
      reconciliation_date: reconciliation.expense_date,
      reconciliation_reception_date: reconciliation.expense_reception_date,
      reconciliation_description: reconciliation.expense_sender_name,
      reconciliation_currency: reconciliation.expense_currency,
      reconcilation_state: reconciliation.expense_state,
    };
  } else {
    recTemporal = {
      reconciliation_object_uid: "NO_UID",
    };
  }

  if (toObject && toObject == DocumentDomain.MOVEMENT) {
    recrefTemporal = {
      reconciliation_reference_object_uid: reconciliationReference.uid,
      reconciliation_reference_account_uid: reconciliationReference.account_uid,
      reconciliation_reference_company_uid: reconciliationReference.company_uid,
      reconciliation_reference_account_number:
        reconciliationReference.movement_account_number,
      reconciliation_reference_amount: parseFloat(
        reconciliationReference.movement_total_amount
      ),
      reconciliation_reference_type: reconciliationReference.movement_type,
      reconciliation_reference_balance: parseFloat(
        reconciliationReference.movement_balance
      ),
      reconciliation_reference_balance_currency:
        reconciliationReference.movement_balance_currency,
      reconciliation_reference_businessNumber: reconciliationReference.movement_reference,
      reconciliation_reference_date: reconciliationReference.movement_date,
      reconciliation_reference_transaction_date:
        reconciliationReference.movement_transaction_date,
      reconciliation_reference_description: reconciliationReference.movement_description,
      reconciliation_reference_currency: reconciliationReference.movement_currency,
      reconciliation_reference_origin_id: reconciliationReference.movement_origin_id,
      reconciliation_reference_object_original_type:
        reconciliationReference.movement_original_type,
      reconciliation_reference_pending: reconciliationReference.movement_pending,
      reconciliation_reference_client_provider:
        reconciliationReference.movement_client_provider,
      reconciliation_reference_sender: reconciliationReference.movement_sender,
      reconciliation_reference_sender_legal_id:
        reconciliationReference.movement_sender_legal_id,
    };
    console.log("rec ref is MOVEMENTX: " + JSON.stringify(recrefTemporal));
  }
  //TODO: cambiar document_sender po document_aditional_info
  else if (toObject && toObject == DocumentDomain.DOCUMENT) {
    recrefTemporal = {
      reconciliation_reference_object_uid: reconciliationReference.uid,
      reconciliation_reference_company_uid: reconciliationReference.company_uid,
      reconciliation_reference_receiver_legal_id:
        reconciliationReference.document_receiver_legal_id,
      reconciliation_reference_sender_legal_id:
        reconciliationReference.document_sender_legal_id,
      reconciliation_reference_amount: parseFloat(
        reconciliationReference.document_total_amount
      ),
      reconciliation_reference_net_amount: parseFloat(
        reconciliationReference.document_net_amount
      ),
      reconciliation_reference_exempt_amount: parseFloat(
        reconciliationReference.document_exempt_amount
      ),
      reconciliation_reference_tax_amount: parseFloat(
        reconciliationReference.document_tax_amount
      ),
      reconciliation_reference_type: reconciliationReference.document_type,
      reconciliation_reference_balance: parseFloat(
        reconciliationReference.document_balance
      ),
      reconciliation_reference_balance_currency:
        reconciliationReference.document_balance_currency,
      reconciliation_reference_businessNumber: reconciliationReference.document_number,
      reconciliation_reference_date: reconciliationReference.document_date,
      reconciliation_reference_reception_date:
        reconciliationReference.document_reception_date,
      reconciliation_reference_description:
        reconciliationReference.document_enterprise_name,
      reconciliation_reference_currency: reconciliationReference.document_currency,
      reconciliation_reference_state: reconciliationReference.document_state,
      reconciliation_reference_isDocument: true,
    };
  } else if (toObject && toObject == DocumentDomain.INVOICE) {
    if (reconciliationReference.document_isDocument) {
      recrefTemporal = {
        reconciliation_reference_object_uid: reconciliationReference.uid,
        reconciliation_reference_company_uid: reconciliationReference.company_uid,
        reconciliation_reference_receiver_legal_id:
          reconciliationReference.document_receiver_legal_id,
        reconciliation_reference_sender_legal_id:
          reconciliationReference.document_sender_legal_id,
        reconciliation_reference_amount: parseFloat(
          reconciliationReference.document_total_amount
        ),
        reconciliation_reference_net_amount: parseFloat(
          reconciliationReference.document_net_amount
        ),
        reconciliation_reference_exempt_amount: parseFloat(
          reconciliationReference.document_exempt_amount
        ),
        reconciliation_reference_tax_amount: parseFloat(
          reconciliationReference.document_total_tax_amount
        ),
        reconciliation_reference_type: reconciliationReference.document_type,
        reconciliation_reference_object_original_type:
          reconciliationReference.document_original_type,
        reconciliation_reference_balance: parseFloat(
          reconciliationReference.document_balance
        ),
        reconciliation_reference_balance_currency:
          reconciliationReference.document_balance_currency,
        reconciliation_reference_businessNumber: reconciliationReference.document_number,
        reconciliation_reference_date: reconciliationReference.document_date,
        reconciliation_reference_reception_date:
          reconciliationReference.document_reception_date,
        reconciliation_reference_description:
          reconciliationReference.document_enterprise_name,
        reconciliation_reference_currency: reconciliationReference.document_currency,
        reconciliation_reference_state: reconciliationReference.document_state,
        reconciliation_reference_enterprise_name:
          reconciliationReference.document_enterprise_name,
        reconciliation_reference_isDocument: true,
      };
      console.log("rec ref is document: " + JSON.stringify(recrefTemporal));
    } else {
      recrefTemporal = {
        reconciliation_reference_object_uid: reconciliationReference.uid,
        reconciliation_reference_company_uid: reconciliationReference.company_uid,
        reconciliation_reference_receiver_legal_id:
          reconciliationReference.invoice_receiver_legal_id,
        reconciliation_reference_sender_legal_id:
          reconciliationReference.invoice_sender_legal_id,
        reconciliation_reference_amount: parseFloat(
          reconciliationReference.invoice_total_amount
        ),
        reconciliation_reference_net_amount: parseFloat(
          reconciliationReference.invoice_net_amount
        ),
        reconciliation_reference_exempt_amount: parseFloat(
          reconciliationReference.invoice_exempt_amount
        ),
        reconciliation_reference_tax_amount: parseFloat(
          reconciliationReference.invoice_tax_amount
        ),
        reconciliation_reference_type: reconciliationReference.invoice_type,
        reconciliation_reference_object_original_type:
          reconciliationReference.invoice_original_type,
        reconciliation_reference_balance_currency:
          reconciliationReference.invoice_balance_currency,
        reconciliation_reference_balance: parseFloat(
          reconciliationReference.invoice_balance
        ),
        reconciliation_reference_businessNumber: reconciliationReference.invoice_number,
        reconciliation_reference_date: reconciliationReference.invoice_date,
        reconciliation_reference_reception_date:
          reconciliationReference.invoice_reception_date,
        reconciliation_reference_description: reconciliationReference.invoice_sender_name,
        reconciliation_reference_currency: reconciliationReference.invoice_currency,
        reconciliation_reference_state: reconciliationReference.invoice_state,
      };
    }
  } else if (toObject && toObject == DocumentDomain.BILL) {
    if (reconciliationReference.document_isDocument) {
      recrefTemporal = {
        reconciliation_reference_object_uid: reconciliationReference.uid,
        reconciliation_reference_company_uid: reconciliationReference.company_uid,
        reconciliation_reference_receiver_legal_id:
          reconciliationReference.document_receiver_legal_id,
        reconciliation_reference_sender_legal_id:
          reconciliationReference.document_sender_legal_id,
        reconciliation_reference_amount: parseFloat(
          reconciliationReference.document_total_amount
        ),
        reconciliation_reference_net_amount: parseFloat(
          reconciliationReference.document_net_amount
        ),
        reconciliation_reference_exempt_amount: parseFloat(
          reconciliationReference.document_exempt_amount
        ),
        reconciliation_reference_tax_amount: parseFloat(
          reconciliationReference.document_total_tax_amount
        ),
        reconciliation_reference_type: reconciliationReference.document_type,
        reconciliation_reference_object_original_type:
          reconciliationReference.document_original_type,
        reconciliation_reference_balance: parseFloat(
          reconciliationReference.document_balance
        ),
        reconciliation_reference_balance_currency:
          reconciliationReference.document_balance_currency,
        reconciliation_reference_businessNumber: reconciliationReference.document_number,
        reconciliation_reference_date: reconciliationReference.document_date,
        reconciliation_reference_reception_date:
          reconciliationReference.document_reception_date,
        reconciliation_reference_description:
          reconciliationReference.document_enterprise_name,
        reconciliation_reference_currency: reconciliationReference.document_currency,
        reconciliation_reference_state: reconciliationReference.document_state,
        reconciliation_reference_enterprise_name:
          reconciliationReference.document_enterprise_name,
        reconciliation_reference_isDocument: true,
      };
    } else {
      recrefTemporal = {
        reconciliation_reference_object_uid: reconciliationReference.uid,
        reconciliation_reference_company_uid: reconciliationReference.company_uid,
        reconciliation_reference_receiver_legal_id:
          reconciliationReference.bill_receiver_legal_id,
        reconciliation_reference_sender_legal_id:
          reconciliationReference.bill_sender_legal_id,
        reconciliation_reference_amount: parseFloat(
          reconciliationReference.bill_total_amount
        ),
        reconciliation_reference_net_amount: parseFloat(
          reconciliationReference.bill_net_amount
        ),
        reconciliation_reference_exempt_amount: parseFloat(
          reconciliationReference.bill_exempt_amount
        ),
        reconciliation_reference_tax_amount: parseFloat(
          reconciliationReference.bill_tax_amount
        ),
        reconciliation_reference_type: reconciliationReference.bill_type,
        reconciliation_reference_object_original_type:
          reconciliationReference.bill_original_type,
        reconciliation_reference_balance_currency:
          reconciliationReference.bill_balance_currency,
        reconciliation_reference_balance: parseFloat(
          reconciliationReference.bill_balance
        ),
        reconciliation_reference_businessNumber: reconciliationReference.bill_number,
        reconciliation_reference_date: reconciliationReference.bill_date,
        reconciliation_reference_reception_date:
          reconciliationReference.bill_reception_date,
        reconciliation_reference_description: reconciliationReference.bill_sender_name,
        reconciliation_reference_currency: reconciliationReference.bill_currency,
        reconciliation_reference_state: reconciliationReference.bill_state,
      };
    }
  } else if (toObject && toObject == DocumentDomain.EXPENSE) {
    console.log(
      "reconciliationReference.document_isDocument:" +
      reconciliationReference.document_isDocument
    );
    if (reconciliationReference.document_isDocument) {
      recrefTemporal = {
        reconciliation_reference_object_uid: reconciliationReference.uid,
        reconciliation_reference_company_uid: reconciliationReference.company_uid,
        reconciliation_reference_receiver_legal_id:
          reconciliationReference.document_receiver_legal_id,
        reconciliation_reference_sender_legal_id:
          reconciliationReference.document_sender_legal_id,
        reconciliation_reference_amount: parseFloat(
          reconciliationReference.document_total_amount
        ),
        reconciliation_reference_net_amount: parseFloat(
          reconciliationReference.document_net_amount
        ),
        reconciliation_reference_exempt_amount: parseFloat(
          reconciliationReference.document_exempt_amount
        ),
        reconciliation_reference_tax_amount: parseFloat(
          reconciliationReference.document_total_tax_amount
        ),
        reconciliation_reference_type: reconciliationReference.document_type,
        reconciliation_reference_object_original_type:
          reconciliationReference.document_original_type,
        reconciliation_reference_balance: parseFloat(
          reconciliationReference.document_balance
        ),
        reconciliation_reference_balance_currency:
          reconciliationReference.document_balance_currency,
        reconciliation_reference_businessNumber: reconciliationReference.document_number,
        reconciliation_reference_date: reconciliationReference.document_date,
        reconciliation_reference_reception_date:
          reconciliationReference.document_reception_date,
        reconciliation_reference_description:
          reconciliationReference.document_enterprise_name,
        reconciliation_reference_currency: reconciliationReference.document_currency,
        reconciliation_reference_state: reconciliationReference.document_state,
        reconciliation_reference_isDocument: true,
      };
    } else {
      recrefTemporal = {
        reconciliation_reference_object_uid: reconciliationReference.uid,
        reconciliation_reference_company_uid: reconciliationReference.company_uid,
        reconciliation_reference_receiver_legal_id:
          reconciliationReference.expense_receiver_legal_id,
        reconciliation_reference_sender_legal_id:
          reconciliationReference.expense_sender_legal_id,
        reconciliation_reference_amount: parseFloat(
          reconciliationReference.expense_total_amount
        ),
        reconciliation_reference_net_amount: parseFloat(
          reconciliationReference.expense_net_amount
        ),
        reconciliation_reference_exempt_amount: parseFloat(
          reconciliationReference.expense_exempt_amount
        ),
        reconciliation_reference_tax_amount: parseFloat(
          reconciliationReference.expense_tax_amount
        ),
        reconciliation_reference_type: reconciliationReference.expense_type,
        reconciliation_reference_object_original_type:
          reconciliationReference.expense_original_type,
        reconciliation_reference_balance_currency:
          reconciliationReference.expense_balance_currency,
        reconciliation_reference_balance: parseFloat(
          reconciliationReference.expense_balance
        ),
        reconciliation_reference_businessNumber: reconciliationReference.expense_number,
        reconciliation_reference_date: reconciliationReference.expense_date,
        reconciliation_reference_reception_date:
          reconciliationReference.expense_reception_date,
        reconciliation_reference_description: reconciliationReference.expense_sender_name,
        reconciliation_reference_currency: reconciliationReference.expense_currency,
        reconciliation_reference_state: reconciliationReference.expense_state,
      };
    }
  } else {
    recrefTemporal = {
      reconciliation_reference_object_uid: "NO_UID_REF",
    };
  }

  /*
  if ((this.invoiceAsReconciliationAddedToMovement.filter((item) => item.reconciliation_reference_object_uid == reconciliationReference.uid)).length > 0) {
    console.log("ya existe");
    alert("El " + recrefTemporal.reconciliation_reference_type + " con valor " + recrefTemporal.reconciliation_reference_total_amount + " ya existe en la lista de conciliaciones seleccionadas.");
    return [-1, -1];
  }
*/
  return [recTemporal, recrefTemporal];
}

export function createInitialReconciliationAndReference(
  reconciliation,
  reconciliationReference,
  fromObject,
  toObject
) {
  console.log("reconciliation: " + JSON.stringify(reconciliation));
  console.log("reference: " + JSON.stringify(reconciliationReference));
  console.log("fromObject: " + fromObject);
  console.log("toObject: " + toObject);
  let recTemporal = {};
  let recrefTemporal = {};
  if (fromObject && fromObject == DocumentDomain.MOVEMENT) {
    recTemporal = {
      reconciliation_object_uid: reconciliation.uid,
      reconciliation_account_uid: reconciliation.account_uid,
      reconciliation_company_uid: reconciliation.company_uid,
      reconciliation_account_number: reconciliation.movement_account_number,
      reconciliation_total_amount: parseFloat(reconciliation.movement_total_amount),
      reconciliation_type: reconciliation.movement_type,
      reconciliation_balance: reconciliation.movement_balance
        ? parseFloat(reconciliation.movement_balance)
        : parseFloat(reconciliation.movement_total_amount),
      reconciliation_balance_currency: reconciliation.movement_balance_currency,
      reconciliation_businessNumber: reconciliation.movement_reference,
      reconciliation_date: reconciliation.movement_date,
      reconciliation_transaction_date: reconciliation.movement_transaction_date,
      reconciliation_description: reconciliation.movement_description,
      reconciliation_currency: reconciliation.movement_currency,
      reconciliation_origin_id: reconciliation.movement_origin_id,
      reconciliation_original_type: reconciliation.movement_original_type,
      reconciliation_pending: reconciliation.movement_pending,
    };
  }
  //TODO: cambiar document_sender po document_aditional_info
  else if (fromObject && fromObject == DocumentDomain.DOCUMENT) {
    recTemporal = {
      reconciliation_object_uid: reconciliation.uid,
      reconciliation_company_uid: reconciliation.company_uid,
      reconciliation_receiver_legal_id: reconciliation.document_receiver_legal_id,
      reconciliation_sender_legal_id: reconciliation.document_sender_legal_id,
      reconciliation_total_amount: parseFloat(reconciliation.document_total_amount),
      reconciliation_net_amount: parseFloat(reconciliation.document_net_amount),
      reconciliation_exempt_amount: parseFloat(reconciliation.document_exempt_amount),
      reconciliation_tax_amount: parseFloat(reconciliation.document_tax_amount),
      reconciliation_type: reconciliation.document_type,
      reconciliation_balance: reconciliation.document_balance
        ? parseFloat(reconciliation.document_balance)
        : parseFloat(reconciliation.document_total_amount),
      reconciliation_balance_currency: reconciliation.document_balance_currency,
      reconciliation_businessNumber: reconciliation.document_number,
      reconciliation_date: reconciliation.document_date,
      reconciliation_reception_date: reconciliation.document_reception_date,
      reconciliation_description: reconciliation.document_sender_name,
      reconciliation_currency: reconciliation.document_currency,
      reconcilation_state: reconciliation.document_state,
    };
  } else if (fromObject && fromObject == DocumentDomain.INVOICE) {
    recTemporal = {
      reconciliation_object_uid: reconciliation.uid,
      reconciliation_company_uid: reconciliation.company_uid,
      reconciliation_receiver_legal_id: reconciliation.invoice_receiver_legal_id,
      reconciliation_sender_legal_id: reconciliation.invoice_sender_legal_id,
      reconciliation_total_amount: parseFloat(reconciliation.invoice_total_amount),
      reconciliation_net_amount: parseFloat(reconciliation.invoice_net_amount),
      reconciliation_exempt_amount: parseFloat(reconciliation.invoice_exempt_amount),
      reconciliation_tax_amount: parseFloat(reconciliation.invoice_tax_amount),
      reconciliation_type: reconciliation.invoice_type,
      reconciliation_balance: reconciliation.invoice_balance
        ? parseFloat(reconciliation.invoice_balance)
        : parseFloat(reconciliation.document_total_amount),
      reconciliation_balance_currency: reconciliation.invoice_balance_currency,
      reconciliation_businessNumber: reconciliation.invoice_number,
      reconciliation_date: reconciliation.invoice_date,
      reconciliation_reception_date: reconciliation.invoice_reception_date,
      reconciliation_description: reconciliation.invoice_sender_name,
      reconciliation_currency: reconciliation.invoice_currency,
      reconcilation_state: reconciliation.invoice_state,
    };
  } else if (fromObject && fromObject == DocumentDomain.BILL) {
    recTemporal = {
      reconciliation_object_uid: reconciliation.uid,
      reconciliation_company_uid: reconciliation.company_uid,
      reconciliation_receiver_legal_id: reconciliation.bill_receiver_legal_id,
      reconciliation_sender_legal_id: reconciliation.bill_sender_legal_id,
      reconciliation_total_amount: parseFloat(reconciliation.bill_total_amount),
      reconciliation_net_amount: parseFloat(reconciliation.bill_net_amount),
      reconciliation_exempt_amount: parseFloat(reconciliation.bill_exempt_amount),
      reconciliation_tax_amount: parseFloat(reconciliation.bill_tax_amount),
      reconciliation_type: reconciliation.bill_type,
      reconciliation_balance: reconciliation.bill_balance
        ? parseFloat(reconciliation.bill_balance)
        : parseFloat(reconciliation.document_total_amount),
      reconciliation_balance_currency: reconciliation.bill_balance_currency,
      reconciliation_businessNumber: reconciliation.bill_number,
      reconciliation_date: reconciliation.bill_date,
      reconciliation_reception_date: reconciliation.bill_reception_date,
      reconciliation_description: reconciliation.bill_sender_name,
      reconciliation_currency: reconciliation.bill_currency,
      reconcilation_state: reconciliation.bill_state,
    };
  } else if (fromObject && fromObject == DocumentDomain.EXPENSE) {
    recTemporal = {
      reconciliation_object_uid: reconciliation.uid,
      reconciliation_company_uid: reconciliation.company_uid,
      reconciliation_receiver_legal_id: reconciliation.expense_receiver_legal_id,
      reconciliation_sender_legal_id: reconciliation.expense_sender_legal_id,
      reconciliation_total_amount: parseFloat(reconciliation.expense_total_amount),
      reconciliation_net_amount: parseFloat(reconciliation.expense_net_amount),
      reconciliation_exempt_amount: parseFloat(reconciliation.expense_exempt_amount),
      reconciliation_tax_amount: parseFloat(reconciliation.expense_tax_amount),
      reconciliation_type: reconciliation.expense_type,
      reconciliation_balance: reconciliation.expense_balance
        ? parseFloat(reconciliation.expense_balance)
        : parseFloat(reconciliation.document_total_amount),
      reconciliation_balance_currency: reconciliation.expense_balance_currency,
      reconciliation_businessNumber: reconciliation.expense_number,
      reconciliation_date: reconciliation.expense_date,
      reconciliation_reception_date: reconciliation.expense_reception_date,
      reconciliation_description: reconciliation.expense_sender_name,
      reconciliation_currency: reconciliation.expense_currency,
      reconcilation_state: reconciliation.expense_state,
    };
  } else {
    recTemporal = {
      reconciliation_object_uid: "NO_UID",
    };
  }

  if (toObject && toObject == DocumentDomain.MOVEMENT) {
    recrefTemporal = {
      reconciliation_reference_object_uid: reconciliationReference.uid,
      reconciliation_reference_account_uid: reconciliationReference.account_uid,
      reconciliation_reference_company_uid: reconciliationReference.company_uid,
      reconciliation_reference_account_number:
        reconciliationReference.movement_account_number,
      reconciliation_reference_amount: parseFloat(
        reconciliationReference.movement_total_amount
      ),
      reconciliation_reference_type: reconciliationReference.movement_type,
      reconciliation_reference_balance: parseFloat(
        reconciliationReference.movement_balance
      ),
      reconciliation_reference_balance_currency:
        reconciliationReference.movement_balance_currency,
      reconciliation_reference_businessNumber: reconciliationReference.movement_reference,
      reconciliation_reference_date: reconciliationReference.movement_date,
      reconciliation_reference_transaction_date:
        reconciliationReference.movement_transaction_date,
      reconciliation_reference_description: reconciliationReference.movement_description,
      reconciliation_reference_currency: reconciliationReference.movement_currency,
      reconciliation_reference_origin_id: reconciliationReference.movement_origin_id,
      reconciliation_reference_object_original_type:
        reconciliationReference.movement_original_type,
      reconciliation_reference_pending: reconciliationReference.movement_pending,
    };
  }
  //TODO: cambiar document_sender po document_aditional_info
  else if (toObject && toObject == DocumentDomain.DOCUMENT) {
    recrefTemporal = {
      reconciliation_reference_object_uid: reconciliationReference.uid,
      reconciliation_reference_company_uid: reconciliationReference.company_uid,
      reconciliation_reference_receiver_legal_id:
        reconciliationReference.document_receiver_legal_id,
      reconciliation_reference_sender_legal_id:
        reconciliationReference.document_sender_legal_id,
      reconciliation_reference_amount: parseFloat(
        reconciliationReference.document_total_amount
      ),
      reconciliation_reference_net_amount: parseFloat(
        reconciliationReference.document_net_amount
      ),
      reconciliation_reference_exempt_amount: parseFloat(
        reconciliationReference.document_exempt_amount
      ),
      reconciliation_reference_tax_amount: parseFloat(
        reconciliationReference.document_tax_amount
      ),
      reconciliation_reference_type: reconciliationReference.document_type,
      reconciliation_reference_balance: reconciliationReference.document_balance_currency,
      reconciliation_reference_balance_currency: parseFloat(
        reconciliationReference.document_balance
      ),
      reconciliation_reference_businessNumber: reconciliationReference.document_number,
      reconciliation_reference_date: reconciliationReference.document_date,
      reconciliation_reference_reception_date:
        reconciliationReference.document_reception_date,
      reconciliation_reference_description: reconciliationReference.document_sender_name,
      reconciliation_reference_currency: reconciliationReference.document_currency,
      reconciliation_reference_state: reconciliationReference.document_state,
    };
  } else if (toObject && toObject == DocumentDomain.INVOICE) {
    recrefTemporal = {
      reconciliation_reference_object_uid: reconciliationReference.uid,
      reconciliation_reference_company_uid: reconciliationReference.company_uid,
      reconciliation_reference_receiver_legal_id:
        reconciliationReference.invoice_receiver_legal_id,
      reconciliation_reference_sender_legal_id:
        reconciliationReference.invoice_sender_legal_id,
      reconciliation_reference_amount: parseFloat(
        reconciliationReference.invoice_total_amount
      ),
      reconciliation_reference_net_amount: parseFloat(
        reconciliationReference.invoice_net_amount
      ),
      reconciliation_reference_exempt_amount: parseFloat(
        reconciliationReference.invoice_exempt_amount
      ),
      reconciliation_reference_tax_amount: parseFloat(
        reconciliationReference.invoice_tax_amount
      ),
      reconciliation_reference_type: reconciliationReference.invoice_type,
      reconciliation_reference_object_original_type:
        reconciliationReference.invoice_original_type,
      reconciliation_reference_balance_currency:
        reconciliationReference.invoice_balance_currency,
      reconciliation_reference_balance: parseFloat(
        reconciliationReference.invoice_balance
      ),
      reconciliation_reference_businessNumber: reconciliationReference.invoice_number,
      reconciliation_reference_date: reconciliationReference.invoice_date,
      reconciliation_reference_reception_date:
        reconciliationReference.invoice_reception_date,
      reconciliation_reference_description: reconciliationReference.invoice_sender_name,
      reconciliation_reference_currency: reconciliationReference.invoice_currency,
      reconciliation_reference_state: reconciliationReference.invoice_state,
    };
  } else if (toObject && toObject == DocumentDomain.BILL) {
    recrefTemporal = {
      reconciliation_reference_object_uid: reconciliationReference.uid,
      reconciliation_reference_company_uid: reconciliationReference.company_uid,
      reconciliation_reference_receiver_legal_id:
        reconciliationReference.bill_receiver_legal_id,
      reconciliation_reference_sender_legal_id:
        reconciliationReference.bill_sender_legal_id,
      reconciliation_reference_amount: parseFloat(
        reconciliationReference.bill_total_amount
      ),
      reconciliation_reference_net_amount: parseFloat(
        reconciliationReference.bill_net_amount
      ),
      reconciliation_reference_exempt_amount: parseFloat(
        reconciliationReference.bill_exempt_amount
      ),
      reconciliation_reference_tax_amount: parseFloat(
        reconciliationReference.bill_tax_amount
      ),
      reconciliation_reference_type: reconciliationReference.bill_type,
      reconciliation_reference_object_original_type: reconciliationReference.bill_original_type,
      reconciliation_reference_balance_currency:
        reconciliationReference.bill_balance_currency,
      reconciliation_reference_balance: parseFloat(reconciliationReference.bill_balance),
      reconciliation_reference_businessNumber: reconciliationReference.bill_number,
      reconciliation_reference_date: reconciliationReference.bill_date,
      reconciliation_reference_reception_date:
        reconciliationReference.bill_reception_date,
      reconciliation_reference_description: reconciliationReference.bill_sender_name,
      reconciliation_reference_currency: reconciliationReference.bill_currency,
      reconciliation_reference_state: reconciliationReference.bill_state,
    };
  } else if (toObject && toObject == DocumentDomain.EXPENSE) {
    recrefTemporal = {
      reconciliation_reference_object_uid: reconciliationReference.uid,
      reconciliation_reference_company_uid: reconciliationReference.company_uid,
      reconciliation_reference_receiver_legal_id:
        reconciliationReference.expense_receiver_legal_id,
      reconciliation_reference_sender_legal_id:
        reconciliationReference.expense_sender_legal_id,
      reconciliation_reference_amount: parseFloat(
        reconciliationReference.expense_total_amount
      ),
      reconciliation_reference_net_amount: parseFloat(
        reconciliationReference.expense_net_amount
      ),
      reconciliation_reference_exempt_amount: parseFloat(
        reconciliationReference.expense_exempt_amount
      ),
      reconciliation_reference_tax_amount: parseFloat(
        reconciliationReference.expense_tax_amount
      ),
      reconciliation_reference_type: reconciliationReference.expense_type,
      reconciliation_reference_object_original_type:
        reconciliationReference.expense_original_type,
      reconciliation_reference_balance_currency:
        reconciliationReference.expense_balance_currency,
      reconciliation_reference_balance: parseFloat(
        reconciliationReference.expense_balance
      ),
      reconciliation_reference_businessNumber: reconciliationReference.expense_number,
      reconciliation_reference_date: reconciliationReference.expense_date,
      reconciliation_reference_reception_date:
        reconciliationReference.expense_reception_date,
      reconciliation_reference_description: reconciliationReference.expense_sender_name,
      reconciliation_reference_currency: reconciliationReference.expense_currency,
      reconciliation_reference_state: reconciliationReference.expense_state,
    };
  } else {
    recrefTemporal = {
      reconciliation_reference_object_uid: "NO_UID_REF",
    };
  }

  if (
    this.invoiceAsReconciliationAddedToMovement.filter(
      (item) => item.reconciliation_reference_object_uid == reconciliationReference.uid
    ).length > 0
  ) {
    console.log("ya existe");
    alert(
      "El " +
      recrefTemporal.reconciliation_reference_type +
      " con valor " +
      recrefTemporal.reconciliation_reference_amount +
      " ya existe en la lista de conciliaciones seleccionadas."
    );
    return [-1, -1];
  }

  this.updateBalanceReconciliationAndReference(recTemporal, recrefTemporal);

  return [recTemporal, recrefTemporal];
}

export function objectAsReconciliation(object, fromObject) {
  //console.log("reconciliatiXon: " + JSON.stringify(object));
  //console.log("fromObject: " + fromObject);
  let recTemporal = {};

  if (fromObject && fromObject == DocumentDomain.MOVEMENT) {
    recTemporal = movementAsReconciliation(object);
  }
  //TODO: cambiar document_sender po document_aditional_info
  else if (fromObject && fromObject == DocumentDomain.DOCUMENT) {
    recTemporal = documentAsReconciliation(object);
  } else if (fromObject && fromObject == DocumentDomain.INVOICE) {
    recTemporal = invoiceAsReconciliation(object);
  } else {
    recTemporal = {
      reconciliation_object_uid: "NO_UID",
    };
  }

  return recTemporal;
}

export function movementAsReconciliation(movement) {
  return {
    reconciliation_object_uid: movement.uid,
    reconciliation_account_uid: movement.account_uid,
    reconciliation_company_uid: movement.company_uid,
    reconciliation_account_number: movement.movement_account_number,
    reconciliation_total_amount: parseFloat(movement.movement_total_amount),
    reconciliation_type: movement.movement_type,
    reconciliation_balance: movement.movement_balance
      ? parseFloat(movement.movement_balance)
      : parseFloat(movement.movement_total_amount),
    reconciliation_balance_currency: movement.movement_balance_currency,
    reconciliation_businessNumber: movement.movement_reference,
    reconciliation_date: movement.movement_date,
    reconciliation_transaction_date: movement.movement_transaction_date,
    reconciliation_description: movement.movement_description,
    reconciliation_currency: movement.movement_currency,
    reconciliation_origin_id: movement.movement_origin_id,
    reconciliation_original_type: movement.movement_original_type,
    reconciliation_pending: movement.movement_pending,
  };
}

export function documentAsReconciliation(document) {
  return {
    reconciliation_object_uid: document.uid,
    reconciliation_company_uid: document.company_uid,
    reconciliation_receiver_legal_id: document.document_receiver_legal_id,
    reconciliation_sender_legal_id: document.document_sender_legal_id,
    reconciliation_total_amount: parseFloat(document.document_total_amount),
    reconciliation_net_amount: parseFloat(document.document_net_amount),
    reconciliation_exempt_amount: parseFloat(document.document_exempt_amount),
    reconciliation_tax_amount: parseFloat(document.document_tax_amount),
    reconciliation_type: document.document_type,
    reconciliation_balance: document.document_balance
      ? parseFloat(document.document_balance)
      : parseFloat(document.document_total_amount),
    reconciliation_balance_currency: document.document_balance_currency,
    reconciliation_businessNumber: document.document_number,
    reconciliation_date: document.document_date,
    reconciliation_reception_date: document.document_reception_date,
    reconciliation_description: document.document_enterprise_name,
    reconciliation_currency: document.document_currency,
    reconcilation_state: document.document_state,
  };
}

export function invoiceAsReconciliation(invoice) {
  return {
    reconciliation_object_uid: invoice.uid,
    reconciliation_company_uid: invoice.company_uid,
    reconciliation_receiver_legal_id: invoice.invoice_receiver_legal_id,
    reconciliation_sender_legal_id: invoice.invoice_sender_legal_id,
    reconciliation_total_amount: parseFloat(invoice.invoice_total_amount),
    reconciliation_net_amount: parseFloat(invoice.invoice_net_amount),
    reconciliation_exempt_amount: parseFloat(invoice.invoice_exempt_amount),
    reconciliation_tax_amount: parseFloat(invoice.invoice_tax_amount),
    reconciliation_type: invoice.invoice_type,
    reconciliation_balance: invoice.invoice_balance
      ? parseFloat(invoice.invoice_balance)
      : parseFloat(invoice.document_total_amount),
    reconciliation_balance_currency: invoice.invoice_balance_currency,
    reconciliation_businessNumber: invoice.invoice_number,
    reconciliation_date: invoice.invoice_date,
    reconciliation_reception_date: invoice.invoice_reception_date,
    reconciliation_description: invoice.invoice_sender_name,
    reconciliation_currency: invoice.invoice_currency,
    reconcilation_state: invoice.invoice_state,
  };
}

export function expenseAsDocument(expense) {
return {
  uid: expense.uid,
  company_uid: expense.company_uid,
  document_type: DocumentDomain.EXPENSE,
  document_date: expense.expense_date,
  document_total_amount: expense.expense_total_amount,
  document_currency: expense.expense_currency,
  document_balance_currency: expense.expense_balance_currency,
  document_balance: expense.expense_balance,
  document_number: expense.expense_number,
  document_enterprise_name: expense.expense_sender_name,
  document_receiver_legal_id: expense.expense_receiver_legal_id,
  document_sender_legal_id: expense.expense_sender_legal_id,
  document_total_tax_amount: expense.expense_tax_amount,
  document_net_amount: expense.expense_net_amount,
  document_exempt_amount: expense.expense_exempt_amount,
  document_state: expense.expense_state,
  document_reception_date: expense.expense_reception_date,
  document_original_type: expense.expense_object_type,
  document_isDocument: true,
  document_isIncome: expense.expense_transaction_type==='OUTFLOW'?true:false,
  document_isActive: expense.expense_is_active,
}

}

export function expenseAsReconciliation(expense) {
  //TODO: revisar pq fue autogenerado
  return {
    reconciliation_object_uid: expense.uid,
    reconciliation_company_uid: expense.company_uid,
    reconciliation_receiver_legal_id: expense.expense_receiver_legal_id,
    reconciliation_sender_legal_id: expense.expense_sender_legal_id,
    reconciliation_total_amount: parseFloat(expense.expense_total_amount),
    reconciliation_net_amount: parseFloat(expense.expense_net_amount),
    reconciliation_exempt_amount: parseFloat(expense.expense_exempt_amount),
    reconciliation_tax_amount: parseFloat(expense.expense_tax_amount),
    reconciliation_type: expense.expense_type,
    reconciliation_balance: expense.expense_balance
      ? parseFloat(expense.expense_balance)
      : parseFloat(expense.document_total_amount),
    reconciliation_balance_currency: expense.expense_balance_currency,
    reconciliation_businessNumber: expense.expense_number,
    reconciliation_date: expense.expense_date,
    reconciliation_reception_date: expense.expense_reception_date,
    reconciliation_description: expense.expense_sender_name,
    reconciliation_currency: expense.expense_currency,
    reconcilation_state: expense.expense_state,
  };
}

export function billAsReconciliation(bill) {
  //TODO: revisar pq fue autogenerado
  return {
    reconciliation_object_uid: bill.uid,
    reconciliation_company_uid: bill.company_uid,
    reconciliation_receiver_legal_id: bill.bill_receiver_legal_id,
    reconciliation_sender_legal_id: bill.bill_sender_legal_id,
    reconciliation_total_amount: parseFloat(bill.bill_total_amount),
    reconciliation_net_amount: parseFloat(bill.bill_net_amount),
    reconciliation_exempt_amount: parseFloat(bill.bill_exempt_amount),
    reconciliation_tax_amount: parseFloat(bill.bill_tax_amount),
    reconciliation_type: bill.bill_type,
    reconciliation_balance: bill.bill_balance
      ? parseFloat(bill.bill_balance)
      : parseFloat(bill.document_total_amount),
    reconciliation_balance_currency: bill.bill_balance_currency,
    reconciliation_businessNumber: bill.bill_number,
    reconciliation_date: bill.bill_date,
    reconciliation_reception_date: bill.bill_reception_date,
    reconciliation_description: bill.bill_sender_name,
    reconciliation_currency: bill.bill_currency,
    reconcilation_state: bill.bill_state,
  };
}

export function referenceAsDocument(reference) {
  console.log(
    "reference.reconciliation_reference_enterprise_name: " +
    reference.reconciliation_reference_enterprise_name
  );
  return {
    uid: reference.reconciliation_reference_object_uid,
    company_uid: reference.reconciliation_reference_company_uid,
    document_receiver_legal_id: reference.reconciliation_reference_receiver_legal_id,
    document_sender_legal_id: reference.reconciliation_reference_sender_legal_id,
    document_total_amount: parseFloat(reference.reconciliation_reference_amount),
    document_net_amount: parseFloat(reference.reconciliation_reference_net_amount),
    document_exempt_amount: parseFloat(reference.reconciliation_reference_exempt_amount),
    document_tax_amount: parseFloat(reference.reconciliation_reference_tax_amount),
    document_type: reference.reconciliation_reference_type,
    document_balance: reference.reconciliation_reference_balance
      ? parseFloat(reference.reconciliation_reference_balance)
      : parseFloat(reference.reconciliation_reference_amount),
    document_balance_currency: reference.reconciliation_reference_balance_currency,
    document_number: reference.reconciliation_reference_businessNumber,
    document_date: reference.reconciliation_reference_date,
    document_reception_date: reference.reconciliation_reference_reception_date,
    document_enterprise_name:
      reference.reconciliation_reference_description ||
      (reference.reconciliation_reference_enterprise_name ?? ""),
    document_currency: reference.reconciliation_reference_currency,
    document_state: reference.reconciliation_reference_state,
    document_isDocument: reference.reconciliation_reference_isDocument ?? false,
    document_original_type: reference.reconciliation_reference_object_original_type,
  };
}

export function referenceAsInvoice(reference) {
  return {
    uid: reference.reconciliation_reference_object_uid,
    company_uid: reference.reconciliation_reference_company_uid,
    invoice_receiver_legal_id: reference.reconciliation_reference_receiver_legal_id,
    invoice_sender_legal_id: reference.reconciliation_reference_sender_legal_id,
    invoice_total_amount: parseFloat(reference.reconciliation_reference_amount),
    invoice_net_amount: parseFloat(reference.reconciliation_reference_net_amount),
    invoice_exempt_amount: parseFloat(reference.reconciliation_reference_exempt_amount),
    invoice_tax_amount: parseFloat(reference.reconciliation_reference_tax_amount),
    invoice_type: reference.reconciliation_reference_type,
    invoice_balance: reference.reconciliation_reference_balance
      ? parseFloat(reference.reconciliation_reference_balance)
      : parseFloat(reference.reconciliation_reference_amount),
    invoice_balance_currency: reference.reconciliation_reference_balance_currency,
    invoice_number: reference.reconciliation_reference_businessNumber,
    invoice_date: reference.reconciliation_reference_date,
    invoice_reception_date: reference.reconciliation_reference_reception_date,
    invoice_description: reference.reconciliation_reference_description,
    invoice_currency: reference.reconciliation_reference_currency,
    invoice_state: reference.reconciliation_reference_state,
  };
}

export function checkEmits(...eventNames) {
  let props;

  if (import.meta.env.DEV && props === getCurrentInstance()?.vnode.props) {
    for (const name of eventNames) {
      const propName = "on" + toPascalCase(name);
      if (typeof props[propName] !== "function")
        console.warn(name + " event listener is missing");
    }
  }

  return eventNames;
}

export function filterInvoices(
  invoices,
  searchTerm,
  incomesSelected,
  outcomesSelected,
  pageNumber,
  pageSize
) {
  if (searchTerm != "") {
    console.log("term: " + searchTerm);

    const docToReturn = invoices.filter((documentA) => {
      // console.log("filterLocalData:" + filterLocalData);
      if (documentA !== null && documentA !== undefined) {
        const documentDate = formatDate(documentA.invoice_date?.toLowerCase());
        const documentNumber = documentA.invoice_number?.toLowerCase();
        // console.log("documentA.invoice_receiver_legal_id?.toLowerCase(): " + documentA.invoice_receiver_legal_id?.toLowerCase());
        // console.log("documentA.invoice_sender_legal_id?.toLowerCase(): " + documentA.invoice_sender_legal_id?.toLowerCase());

        const documentReceiver = documentA.invoice_receiver_legal_id
          ?.toLowerCase()
          .replace(/\./g, "");
        const documentSender = documentA.invoice_sender_legal_id
          ?.toLowerCase()
          .replace(/\./g, "");
        const documentType = documentA.invoice_type?.toLowerCase();
        const documentTotalAmount = documentA.invoice_total_amount;
        const documentName = documentA.invoice_client_provider?.toLowerCase();
        // console.log("documentReceiver: " + documentReceiver);
        //  console.log("documentSender: " + documentSender);
        return (
          (incomesSelected &&
            documentTotalAmount >= 0 &&
            (documentDate?.includes(searchTerm) ||
              documentNumber?.includes(searchTerm) ||
              documentReceiver?.includes(searchTerm) ||
              documentSender?.includes(searchTerm) ||
              documentType?.includes(searchTerm) ||
              documentName?.includes(searchTerm) ||
              documentTotalAmount?.toString().includes(searchTerm))) ||
          (outcomesSelected &&
            documentTotalAmount < 0 &&
            (documentDate?.includes(searchTerm) ||
              documentNumber?.includes(searchTerm) ||
              documentReceiver?.includes(searchTerm) ||
              documentSender?.includes(searchTerm) ||
              documentType?.includes(searchTerm) ||
              documentName?.includes(searchTerm) ||
              documentTotalAmount?.toString().includes(searchTerm)))
        );
      }
      console.log("search temr: " + searchTerm);
    });
    return docToReturn;
  } else {
    const docToReturn = invoices.filter((documentB) => {
      const documentAmount = documentB?.invoice_total_amount;

      return (
        (incomesSelected && documentAmount >= 0) ||
        (outcomesSelected && documentAmount < 0)
      );
    });
    return docToReturn;
  }
}

export function filterClients(
  clients,
  searchTerm,
  incomesSelected,
  outcomesSelected,
  pageNumber,
  pageSize
) {
  //console.log("clients en filterClients: " + JSON.stringify(clients));
  if (searchTerm != "") {
    searchTerm = searchTerm.trim();
    //console.log("term s: " + searchTerm);
    //console.log("clients: " + JSON.stringify(clients));

    const clientToReturn = clients.filter((clientA) => {
      //console.log("documentA: " + JSON.stringify(documentA));
      if (clientA !== null && clientA !== undefined) {
        const clientName = clientA.clientLegalName?.toLowerCase();
        const clientLegalId = clientA.clientLegalId?.toLowerCase().replace(/\./g, "");
        const clientDebtAmount = clientA.totalDebtAmount;
        const clientPayedAmount = clientA.totalPayedAmount;
        console.log("incomesSelected->: " + incomesSelected);
        console.log("outcomesSelected->: " + outcomesSelected);
        console.log("clientName->: " + clientName);
        console.log("clientName?.i ncludes(searchTerm): " + clientName?.includes(searchTerm));
        return (
          (incomesSelected &&
            clientDebtAmount >= 0 &&
            (clientName?.includes(searchTerm) ||
              clientLegalId?.includes(searchTerm) ||
              clientDebtAmount?.toString().includes(searchTerm) ||
              clientPayedAmount?.toString().includes(searchTerm))) ||
          (outcomesSelected &&
            clientPayedAmount < 0 &&
            (clientName?.includes(searchTerm) ||
              clientLegalId?.includes(searchTerm) ||
              clientDebtAmount?.toString().includes(searchTerm) ||
              clientPayedAmount?.toString().includes(searchTerm)))
        );
      }
      console.log("search temr: " + searchTerm);
    });
    return clientToReturn;
  } else {
    const clientToReturn = clients.filter((clientB) => {
      const clientDebtAmount = clientB?.totalDebtAmount;
      /*
            return (
              (incomesSelected && clientDebtAmount >= 0) ||
              (outcomesSelected && clientDebtAmount < 0)
            );
      */
      return clientB;
    });
    return clientToReturn;
  }
}


export function filterProviders(
  providers,
  searchTerm,
  incomesSelected,
  outcomesSelected,
  pageNumber,
  pageSize
) {
  console.log("providers en filterProviders: " + JSON.stringify(providers));
  if (searchTerm != "") {
    searchTerm = searchTerm.trim();
    console.log("term s: " + searchTerm);
    console.log("providers: " + JSON.stringify(providers));

    const providerToReturn = providers.filter((providerA) => {
      //console.log("documentA: " + JSON.stringify(documentA));
      if (providerA !== null && providerA !== undefined) {
        const providerName = providerA.providerLegalName?.toLowerCase();
        const providerLegalId = providerA.providerLegalId?.toLowerCase().replace(/\./g, "");
        const providerCreditAmount = providerA.totalCreditAmount;
        const providerPayedAmount = providerA.totalPayedAmount;
        console.log("incomesSelected->: " + incomesSelected);
        console.log("outcomesSelected->: " + outcomesSelected);
        console.log("providerName->: " + providerName);
        console.log("providerName?.i ncludes(searchTerm): " + providerName?.includes(searchTerm));
        return (
          (incomesSelected &&
            providerCreditAmount >= 0 &&
            (providerName?.includes(searchTerm) ||
              providerLegalId?.includes(searchTerm) ||
              providerCreditAmount?.toString().includes(searchTerm) ||
              providerPayedAmount?.toString().includes(searchTerm))) ||
          (outcomesSelected &&
            providerCreditAmount < 0 &&
            (providerName?.includes(searchTerm) ||
              providerLegalId?.includes(searchTerm) ||
              providerCreditAmount?.toString().includes(searchTerm) ||
              providerPayedAmount?.toString().includes(searchTerm)))
        );
      }
      console.log("search temr: " + searchTerm);
    });
    return providerToReturn;
  } else {
    const providerToReturn = providers.filter((providerB) => {
      const providerCreditAmount = providerB?.providerCreditAmount;
      /*
            return (
              (incomesSelected && clientDebtAmount >= 0) ||
              (outcomesSelected && clientDebtAmount < 0)
            );
      */
      return providerB;
    });
    return providerToReturn;
  }
}


export function filterCollaborators(
  collaborators,
  searchTerm,
  incomesSelected,
  outcomesSelected,
  pageNumber,
  pageSize
) {
  //  console.log("collaborators en filterCollaborators: " + JSON.stringify(collaborators));
  if (searchTerm != "") {
    searchTerm = searchTerm.trim();
    console.log("term s: " + searchTerm);
    console.log("collaborators: " + JSON.stringify(collaborators));

    const collaboratorToReturn = collaborators.filter((collaboratorA) => {
      //console.log("documentA: " + JSON.stringify(documentA));
      if (collaboratorA !== null && collaboratorA !== undefined) {
        const collaboratorName = collaboratorA.collaboratorLegalName?.toLowerCase();
        const collaboratorLegalId = collaboratorA.collaboratorLegalId?.toLowerCase().replace(/\./g, "");
        const collaboratorAmount = collaboratorA.totalAmount;
        const collaboratorPayedAmount = collaboratorA.totalPayedAmount;
        //console.log("incomesSelected->: " + incomesSelected);
        //console.log("outcomesSelected ->: " + outcomesSelected);
        //console.log("collaboratorName->: " + collaboratorName);
        //console.log("collaboratorName?.i ncludes(searchTerm): " + collaboratorName?.includes(searchTerm));
        return (
          (incomesSelected &&
            collaboratorAmount >= 0 &&
            (collaboratorName?.includes(searchTerm) ||
              collaboratorLegalId?.includes(searchTerm) ||
              collaboratorAmount?.toString().includes(searchTerm) ||
              collaboratorPayedAmount?.toString().includes(searchTerm))) ||
          (outcomesSelected &&
            collaboratorAmount < 0 &&
            (collaboratorName?.includes(searchTerm) ||
              collaboratorLegalId?.includes(searchTerm) ||
              collaboratorAmount?.toString().includes(searchTerm) ||
              collaboratorPayedAmount?.toString().includes(searchTerm)))
        );
      }
      console.log("search temr: " + searchTerm);
    });
    return collaboratorToReturn;
  } else {
    const collaboratorToReturn = collaborators.filter((collaboratorB) => {
      const collaboratorAmount = collaboratorB?.providerAmount;
      /*
            return (
              (incomesSelected && clientDebtAmount >= 0) ||
              (outcomesSelected && clientDebtAmount < 0)
            );
      */
      return collaboratorB;
    });
    return collaboratorToReturn;
  }
}


export function filterEmployees(
  employees,
  searchTerm,
  incomesSelected,
  outcomesSelected,
  pageNumber,
  pageSize
) {
  //console.log("employees en filterEmployees: " + JSON.stringify(employees));
  if (searchTerm != "") {
    searchTerm = searchTerm.trim();
    console.log("term s: " + searchTerm);
    console.log("employees: " + JSON.stringify(employees));

    const employeeToReturn = employees.filter((employeeA) => {
      //console.log("documentA: " + JSON.stringify(documentA));
      if (employeeA !== null && employeeA !== undefined) {
        const employeeName = employeeA.employeeLegalName?.toLowerCase();
        const employeeLegalId = employeeA.employeeLegalId?.toLowerCase().replace(/\./g, "");
        const employeeAmount = employeeA.totalAmount;
        const employeePayedAmount = employeeA.totalPayedAmount;
        //console.log("incomesSelected->: " + incomesSelected);
        //console.log("outcomesSelected ->: " + outcomesSelected);
        //console.log("employeeName->: " + employeeName);
        //console.log("employeeName?.i ncludes(searchTerm): " + employeeName?.includes(searchTerm));
        return (
          (
            (employeeName?.includes(searchTerm) ||
              employeeLegalId?.includes(searchTerm) ||
              employeeAmount?.toString().includes(searchTerm) ||
              employeePayedAmount?.toString().includes(searchTerm)))
        );
      }
      console.log("search temr: " + searchTerm);
    });
    return employeeToReturn;
  } else {
    const employeeToReturn = employees.filter((employeeB) => {
      const employeeAmount = employeeB?.providerAmount;
      /*
            return (
              (incomesSelected && clientDebtAmount >= 0) ||
              (outcomesSelected && clientDebtAmount < 0)
            );
      */
      return employeeB;
    });
    return employeeToReturn;
  }
}



export function filterDocuments(
  documents,
  searchTerm,
  incomesSelected,
  outcomesSelected,
  pageNumber,
  pageSize
) {
  if (!documents || documents.length === 0) return [];

  // Normalizar término de búsqueda una sola vez
  const term = searchTerm ? searchTerm.toString().trim().toLowerCase() : "";
  const hasSearchTerm = term !== "";

  return documents.filter((doc) => {
    if (!doc) return false;

    // 1. Filtro por Tipo (Ingreso/Egreso)
    const origin = doc.document_origin;
    const amount = doc.document_total_amount;
    const isIncome = doc.document_isIncome;
    console.log("origin:" + origin);
    console.log("isIncome:" + isIncome);
    console.log("amount:" + amount);
    console.log("incomesSelected:" + incomesSelected);
    console.log("outcomesSelected:" + outcomesSelected);

    if (origin === 'LIBROCOMPRA') {
      if (!outcomesSelected) return false;
    } else if (origin === 'LIBROVENTA') {
      if (!incomesSelected) return false;
    } else {
                  
      if (isIncome && !incomesSelected) return false;
      if (!isIncome && !outcomesSelected) return false;
    }

    // 2. Filtro por búsqueda de texto
    if (!hasSearchTerm) return true;

    // Helper para búsqueda segura
    const matches = (val) => {
      if (val === null || val === undefined) return false;
      return String(val).toLowerCase().replace(/\./g, "").replace(/-/g, "").includes(term);
    };

    const dateStr = doc.document_date ? formatDate(doc.document_date) : "";

    return (
      matches(dateStr) ||
      matches(doc.document_number) ||
      matches(doc.document_receiver_legal_id) ||
      matches(doc.document_sender_legal_id) ||
      matches(doc.document_type) ||
      matches(doc.document_enterprise_name) ||
      matches(doc.document_type_data) ||
      matches(amount)
    );
  });
}

export function filterReferences(
  references,
  searchTerm,
  incomesSelected,
  outcomesSelected,
  pageNumber,
  pageSize
) {
  if (searchTerm != "") {
    console.log(
      "references length: " +
      references.length +
      " searchTerm: " +
      searchTerm +
      " incomesSelected: " +
      incomesSelected +
      " outcomesSelected: " +
      outcomesSelected +
      " pageNumber: " +
      pageNumber +
      " pageSize: " +
      pageSize
    );
    console.log(" references:" + JSON.stringify(references));
    const refToReturn = references?.filter((referenceA) => {
      if (referenceA !== null && referenceA !== undefined) {
        const referenceDate = formatDate(
          referenceA.reconciliation_reference_date.toLowerCase()
        );
        const referenceType = referenceA.reconciliation_reference_type.toLowerCase();
        const referenceDescription = referenceA.reconciliation_reference_description?.toLowerCase();
        const referenceTotalAmount = referenceA.reconciliation_reference_amount;
        const referenceAssignAmount =
          Math.abs(referenceA.reconciliation_reference_amount) -
          Math.abs(referenceA.reconciliation_reference_balance);
        const referenceBalance = referenceA.reconciliation_reference_balance;
        const referenceClientProvider = referenceA.reconciliation_reference_description
          ?.toLowerCase()
          .replace(/\./g, "");
        const referenceTypeFormat = referenceA.reconciliation_reference_type?.toLowerCase();

        return (
          (incomesSelected &&
            referenceTotalAmount >= 0 &&
            (referenceDate?.includes(searchTerm) ||
              referenceType?.includes(searchTerm) ||
              referenceDescription?.includes(searchTerm) ||
              referenceTotalAmount?.toString().includes(searchTerm) ||
              referenceAssignAmount?.toString().includes(searchTerm) ||
              referenceClientProvider?.toString().includes(searchTerm) ||
              referenceTypeFormat?.toString().includes(searchTerm) ||
              referenceBalance?.toString().includes(searchTerm))) ||
          (outcomesSelected &&
            movementTotalAmount < 0 &&
            (referenceDate?.includes(searchTerm) ||
              referenceType?.includes(searchTerm) ||
              referenceDescription?.includes(searchTerm) ||
              referenceTotalAmount?.toString().includes(searchTerm) ||
              referenceAssignAmount?.toString().includes(searchTerm) ||
              referenceClientProvider?.toString().includes(searchTerm) ||
              referenceTypeFormat?.toString().includes(searchTerm) ||
              referenceBalance?.toString().includes(searchTerm)))
        );
      }
    });
    return refToReturn;
  } else {
    const refToReturn = references?.filter((referenceB) => {
      const referenceTotalAmount = referenceB?.reconciliation_reference_amount;

      return (
        (incomesSelected && referenceTotalAmount >= 0) ||
        (outcomesSelected && referenceTotalAmount < 0)
      );
    });
    return refToReturn;
  }
}

export async function searchMovements(companyId, searchTerm) {
  if (searchTerm != "") {
    const pageMovement = await useMovementCompanySearch(myCompanyId, searchTerm);
    console.log("pageMovement search: " + JSON.stringify(pageMovement));
    let elementsDB = pageMovement.getContent();
    let totalElements = pageMovement.getTotalElements();
    console.log("count: " + totalElements);
    elementsDB = elementsDB.map((element) => ({
      ...element,
      movement_type_format: formatMovementType(
        element.movement_type,
        element.movement_original_type,
        element.movement_total_amount
      ),
      movement_assign_format: Math.abs(
        Math.abs(element.movement_total_amount) - element.movement_balance
      ),
      movement_client_provider:
        element.movement_sender +
        " " +
        formatRut(element.movement_sender_legal_id) +
        " " +
        element.movement_receiver +
        " " +
        formatRut(element.movement_receiver_legal_id),
    }));
    return elementsDB;
  }
}

export async function loadMoreMovements(
  movements,
  searchTerm,
  myCompanyId,
  incomesSelected,
  outcomesSelected,
  pageDB,
  pageSizeDB,
  pageNumber,
  pageSize
) {
  try {
    if (searchTerm != "") {
      const defaultFilter = new Filter("company_uid", "equal", myCompanyId);

      const filterAmount = new Filter("movement_amount", "contains", searchTerm);
      const filterDate = new Filter("movement_date", "equal", searchTerm);
      const filterDescription = new Filter(
        "movement_description",
        "contains",
        searchTerm
      );
      searchTerm = searchTerm.replace(/-/g, "");
      const filterComment = new Filter("movement_comment", "contains", searchTerm);
      const filterSender = new Filter("movement_sender_legal_id", "contains", searchTerm);
      const filterReceiver = new Filter(
        "movement_receiver_legal_id",
        "contains",
        searchTerm
      );

      let arrayFilters = [];
      arrayFilters.push(defaultFilter);
      arrayFilters.push(filterAmount);
      arrayFilters.push(filterDate);
      arrayFilters.push(filterDescription);
      arrayFilters.push(filterComment);
      arrayFilters.push(filterSender);
      arrayFilters.push(filterReceiver);

      const myOrder = new Order("movement_date", "desc");
      const criteria = new Criteria(pageDB, pageSizeDB, arrayFilters, myOrder);

      console.log("criteria: " + JSON.stringify(criteria));
      //const pageMovement = await useMovementFullCompanyCriteria(myCompanyId, criteria);
      //const pageMovement = await useMovementFullDBCompanyCriteria(myCompanyId, criteria);
      const pageMovement = await useMovementFullDBCompanySearch(myCompanyId, searchTerm);

      //      console.log("pageMovementY: " + JSON.stringify(pageMovement));

      let elementsDB = pageMovement.getContent();
      let totalElements = pageMovement.getTotalElements();
      console.log("count: " + totalElements);
      elementsDB = elementsDB.map((element) => ({
        ...element,
        movement_date_format: formatDate(element.movement_date),
        movement_bank_format: formatBank(element.movement_bank),
        movement_type_format: formatSimpleMovementType(
          element.movement_type,
          element.movement_original_type,
          element.movement_total_amount
        ),
        movement_description_completed: formatMovementDescription(element),
        movement_total_amount_with_currency:
          formatMoneyLatam(element.movement_total_amount) +
          " " +
          element.movement_currency,
        movement_assign_format_with_currency:
          formatMoneyLatam(
            Math.abs(Math.abs(element.movement_total_amount) - element.movement_balance)
          ) +
          " " +
          element.movement_currency,
        movement_balance_format_with_currency:
          formatMoneyLatam(element.movement_balance) + " " + element.movement_currency,

        movement_assign_format: Math.abs(
          Math.abs(element.movement_total_amount) - element.movement_balance
        ),
        movement_client_provider:
          element.movement_sender +
          " " +
          formatRut(element.movement_sender_legal_id) +
          " " +
          element.movement_receiver +
          " " +
          formatRut(element.movement_receiver_legal_id),
      }));
      return elementsDB;
    }
  } catch (error) {
    console.log("error en loadMoreMovements: " + error);
    return [];
  }
}

export async function loadMoreDocumentsClient(searchTerm, companyId, clientId) {
  try {
    if (searchTerm != "") {
      console.log("(functions) loadMoreDocumentsClient searchTerm: " + searchTerm);
      console.log("(functions) loadMoreDocumentsClient companyId: " + companyId);

      const pageDocument = await useDocumentFullDBCompanySearchClient(
        companyId,
        searchTerm,
        clientId
      );

      let elementsDB = pageDocument.getContent();
      let totalElements = pageDocument.getTotalElements();
      console.log("(functions) loadMoreDocumentsClient count: " + totalElements);
      console.log("(functions) loadMoreDocumentsClient elementsDB: " + JSON.stringify(elementsDB));
      elementsDB = elementsDB.map((element) => ({
        ...element,
        document_date_format: formatDate(element.document_date),
        //        document_type_data: formatDocumentSimpleType(element, companyId),
        document_sender_receiver: formatDocumentSenderOrReceiver(element, companyId),
        document_type_data: formatDocumentFullType(element, companyId),
      }));
      console.log("(functions) loadMoreDocumentsClient elementsDB length: " + JSON.stringify(elementsDB.length));
      return elementsDB;

    }
  } catch (error) {
    console.log("error en loadMoreDocumentsClient: " + error);
    return [];
  }

}



export async function loadMoreDocumentsProvider(searchTerm, companyId, providerId, pageNumber, pageSize) {
  try {
    if (searchTerm != "") {
      console.log("(functions) loadMoreDocumentsProvider searchTerm: " + searchTerm);
      console.log("(functions) loadMoreDocumentsProvider companyId: " + companyId);
      console.log("(functions) loadMoreDocumentsProvider providerId: " + providerId);
      console.log("(functions) loadMoreDocumentsProvider pageNumber: " + pageNumber);
      console.log("(functions) loadMoreDocumentsProvider pageSize: " + pageSize);


      const typeFilter = new Filter("document_original_type", "IN", "'60','61','56'");

      let arrayFilters = [];
      arrayFilters.push(typeFilter);

      const criteria = new Criteria(pageNumber, pageSize, arrayFilters);



      const pageDocument = await useDocumentFullDBCompanySearchProviderCriteria(
        companyId,
        searchTerm,
        providerId,
        criteria
      );

      console.log("(functions) loadMoreDocumentsProvider pageDocument: " + JSON.stringify(pageDocument));
      let elementsDB = pageDocument.getContent();
      let totalElements = pageDocument.getTotalElements();
      console.log("(functions) loadMoreDocumentsProvider count: " + totalElements);
      console.log("(functions) loadMoreDocumentsProvider elementsDB: " + JSON.stringify(elementsDB));
      elementsDB = elementsDB.map((element) => ({
        ...element,
        document_date_format: formatDate(element.document_date),
        //        document_type_data: formatDocumentSimpleType(element, companyId),
        document_sender_receiver: formatDocumentSenderOrReceiver(element, companyId),
        document_type_data: formatDocumentFullType(element, companyId),
      }));
      console.log("(functions) loadMoreDocumentsProvider elementsDB length: " + JSON.stringify(elementsDB.length));
      return elementsDB;

    }
  } catch (error) {
    console.log("error en loadMoreDocumentsProvider: " + error);
    return [];
  }

}


export async function loadMoreDocuments(
  searchTerm,
  myCompanyData
) {
  try {
    if (searchTerm && searchTerm.trim() !== "") {
      const pageDocument = await useDocumentFullDBCompanySearch(
        myCompanyData,
        searchTerm
      );

      let elementsDB = pageDocument.getContent();

      if (elementsDB) {
        elementsDB = elementsDB.map((element) => ({
          ...element,
          document_type_data: formatDocumentFullType(element, myCompanyData),
          document_expected_pay_date_format: formatDate(element.document_expected_pay_date),
          document_date_format: formatDate(element.document_date),
          document_total_amount_with_currency: formatMoneyLatam(element.document_total_amount) + " " + element.document_currency,
          document_assign_format: Math.abs(Math.abs(element.document_total_amount) - (element.document_balance ?? 0)),
          document_assign_format_with_currency: formatMoneyLatam(Math.abs(Math.abs(element.document_total_amount) - (element.document_balance ?? 0))) + " " + element.document_currency,
          document_business_number: element.document_number,
          document_client_provider: element.document_enterprise_name,
          document_balance_format_with_currency: formatMoneyLatam(element.document_balance) + " " + element.document_currency,
          document_description_completed: formatDocumentDescription(element),
        }));
        return elementsDB;
      }
    }
    return [];
  } catch (error) {
    console.error("Error en loadMoreDocuments: ", error);
    return [];
  }
}

export function filterMovements(
  movements,
  searchTerm,
  incomesSelected,
  outcomesSelected,
  pageNumber,
  pageSize
) {
  if (searchTerm != "") {
    console.log(
      "movements length: " +
      movements.length +
      " searchTerm: " +
      searchTerm +
      " incomesSelected: " +
      incomesSelected +
      " outcomesSelected: " +
      outcomesSelected +
      " pageNumber: " +
      pageNumber +
      " pageSize: " +
      pageSize
    );
    console.log(" movements:" + movements.length);
    const movToReturn = movements?.filter((movementA) => {
      if (movementA !== null && movementA !== undefined) {
        const movementDate = formatDate(movementA.movement_date.toLowerCase());
        const movementType = movementA.movement_type.toLowerCase();
        const movementDescription = movementA.movement_description?.toLowerCase().replace(/\./g, "").replace(/-/g, "");
        const movementTotalAmount = movementA.movement_total_amount;
        const movementAssignAmount =
          Math.abs(movementA.movement_total_amount) -
          Math.abs(movementA.movement_balance);
        const movementBalance = movementA.movement_balance;
        const movementClientProvider = movementA.movement_client_provider
          ?.toLowerCase()
          .replace(/\./g, "").replace(/-/g, "");
        const movementTypeFormat = movementA.movement_type_format?.toLowerCase();

        return (
          (incomesSelected &&
            movementTotalAmount >= 0 &&
            (movementDate?.includes(searchTerm) ||
              movementType?.includes(searchTerm) ||
              movementDescription?.includes(searchTerm) ||
              movementTotalAmount?.toString().includes(searchTerm) ||
              movementAssignAmount?.toString().includes(searchTerm) ||
              movementClientProvider?.toString().includes(searchTerm) ||
              movementTypeFormat?.toString().includes(searchTerm) ||
              movementBalance?.toString().includes(searchTerm))) ||
          (outcomesSelected &&
            movementTotalAmount < 0 &&
            (movementDate?.includes(searchTerm) ||
              movementType?.includes(searchTerm) ||
              movementDescription?.includes(searchTerm) ||
              movementTotalAmount?.toString().includes(searchTerm) ||
              movementAssignAmount?.toString().includes(searchTerm) ||
              movementClientProvider?.toString().includes(searchTerm) ||
              movementTypeFormat?.toString().includes(searchTerm) ||
              movementBalance?.toString().includes(searchTerm)))
        );
      }
    });
    return movToReturn;
  } else {
    const movToReturn = movements?.filter((movementB) => {
      const movementAmount = movementB?.movement_total_amount;

      return (
        (incomesSelected && movementAmount >= 0) ||
        (outcomesSelected && movementAmount < 0)
      );
    });
    return movToReturn;
  }
}

export function getFiltersForMovement(companyId, pageDB, pageSizeDB) {
  const defaultFilter = new Filter("company_uid", "=", companyId);
  // const filterBalance = new Filter("movement_balance", ">", 0);
  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  // arrayFilters.push(filterBalance);
  const criteria = new Criteria(pageDB, pageSizeDB, arrayFilters);
  return criteria;
}

export function getFiltersForClient(companyId, pageDB, pageSizeDB) {
  const defaultFilter = new Filter("company_uid", "=", companyId);
  // const filterBalance = new Filter("movement_balance", ">", 0);
  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  // arrayFilters.push(filterBalance);
  const criteria = new Criteria(pageDB, pageSizeDB, arrayFilters);
  return criteria;
}


export function getDocumentFiltersForCredit(type, pageDB, pageSizeDB) {
  const defaultFilter = new Filter("document_type", "=", type);
  // const filterBalance = new Filter("movement_balance", ">", 0);
  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  // arrayFilters.push(filterBalance);
  const criteria = new Criteria(pageDB, pageSizeDB, arrayFilters);
  return criteria;
}


export function getFiltersForDocument(companyId, pageDB, pageSizeDB) {
  const defaultFilter = new Filter("company_uid", "=", companyId);

  let arrayFilters = [];
  arrayFilters.push(defaultFilter);

  const criteria = new Criteria(pageDB, pageSizeDB, arrayFilters);
  return criteria;
}

export function getFiltersForExpense(companyId, pageDB, pageSizeDB) {
  const defaultFilter = new Filter("company_uid", "=", companyId);
  const expenseFilter = new Filter("document_type", "=", DocumentDomain.EXPENSE);
  const activeFilter = new Filter("document_isActive", "=", true);

  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  arrayFilters.push(expenseFilter);
  arrayFilters.push(activeFilter);

  const criteria = new Criteria(pageDB, pageSizeDB, arrayFilters);
  return criteria;
}


export function resumeAutoreconciliationsDefaultColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Fecha",
      colName: "autoreconciliation_date",
      orderName: "autoreconciliation_date",
      display: true,
      showXS: true,
    },
    {
      colNumber: 2,
      colTitle: "Tipo",
      colName: "autoreconciliation_description_complete",
      orderName: "autoreconciliation_description_complete",
      display: true,
      showXS: true,
    },
    {
      colNumber: 3,
      colTitle: "Monto Conciliado",
      colName: "autoreconciliation_amount_references_format",
      orderName: "autoreconciliation_amount_references_format",
      display: true,
      showXS: true,
    },
    {
      colNumber: 4,
      colTitle: "Emisor",
      colName: "autoreconciliation_sender",
      orderName: "autoreconciliation_sender",
      display: true,
      showXS: false,
    },
    {
      colNumber: 5,
      colTitle: "Receptor",
      colName: "autoreconciliation_receiver",
      orderName: "autoreconciliation_receiver",
      display: true,
      showXS: false,
    },
    {
      colNumber: 6,
      colTitle: "Número/Descripción",
      colName: "autoreconciliation_description",
      orderName: "autoreconciliation_description",
      display: true,
      showXS: true,
    },


  ];
  return columns;
}

export function resumeAutoreconciliationsReferencesDefaultColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Fecha",
      colName: "autoreconciliation_reference_date",
      orderName: "autoreconciliation_reference_date",
      display: true,
      showXS: true,
    },
    {
      colNumber: 2,
      colTitle: "Tipo",
      colName: "autoreconciliation_reference_description_complete",
      orderName: "autoreconciliation_reference_description_complete",
      display: true,
      showXS: true,
    },
    {
      colNumber: 3,
      colTitle: "Monto",
      colName: "autoreconciliation_reference_amount_format",
      orderName: "autoreconciliation_reference_amount_format",
      display: true,
      showXS: true,
    },
    {
      colNumber: 4,
      colTitle: "Emisor",
      colName: "autoreconciliation_reference_sender",
      orderName: "autoreconciliation_reference_sender",
      display: true,
      showXS: false,
    },
    {
      colNumber: 5,
      colTitle: "Receptor",
      colName: "autoreconciliation_reference_receiver",
      orderName: "autoreconciliation_reference_receiver",
      display: true,
      showXS: false,
    },
    {
      colNumber: 6,
      colTitle: "Número/Descripción",
      colName: "autoreconciliation_reference_description",
      orderName: "autoreconciliation_reference_description",
      display: true,
      showXS: true,
    },


  ];
  return columns;
}


export function resumeProvidersDefaultColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Proveedor",
      colName: "providerLegalName",
      orderName: "providerLegalName",
      display: true,
      showXS: true,
      gridWidth: '1.5fr'
    },
    {
      colNumber: 2,
      colTitle: "Rut",
      colName: "providerLegalIdFormat",
      orderName: "providerLegalIdFormat",
      display: true,
      showXS: false,
      gridWidth: '1.0fr'
    },
    {
      colNumber: 3,
      colTitle: "Documentos Adeudados",
      colName: "totalCreditDocument",
      orderName: "totalCreditDocument",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 4,
      colTitle: "Monto Adeudado",
      colName: "totalCredAmountFormat",
      orderName: "totalCreditAmount",
      display: true,
      showXS: true,
      gridWidth: '0.75fr',
      align: 'right',
    },
    {
      colNumber: 5,
      colTitle: "Monto > 90 días",
      colName: "totalCred90AmountFormat",
      orderName: "totalCred90Amount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '0.75fr'
    },
    {
      colNumber: 6,
      colTitle: "Monto > 60 días",
      colName: "totalCred60AmountFormat",
      orderName: "totalCred60Amount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '0.75fr'
    },
    {
      colNumber: 7,
      colTitle: "Monto > 30 días",
      colName: "totalCred30AmountFormat",
      orderName: "totalCred30Amount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '0.75fr'
    },
    {
      colNumber: 8,
      colTitle: "Monto < 30 días",
      colName: "totalCredLess30AmountFormat",
      orderName: "totalCredLess30Amount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '0.75fr'
    },

    {
      colNumber: 9,
      colTitle: "Monto Pagado",
      colName: "totalPayedAmountFormat",
      orderName: "totalPayedAmount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '0.75fr',
    },
    {
      colNumber: 10,
      colTitle: "Documentos Pagados",
      colName: "totalPayedDocument",
      orderName: "totalPayedDocument",
      hide: true,
      display: false,
      showXS: false,
    },
    {
      colNumber: 11,
      colTitle: "RutNoFormat",
      colName: "providerLegalId",
      orderName: "providerLegalId",
      hide: true,
      display: false,
      showXS: false,
    },
    {
      colNumber: 12,
      colTitle: "Monto AdeudadoNoFormat",
      colName: "totalCredAmount",
      orderName: "totalCredAmount",
      display: false,
      hide: true,
      showXS: false,
    },
  ];
  return columns;
}



export function resumeBusinessDefaultColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Cliente",
      colName: "clienteLegalName",
      orderName: "clienteLegalName",
      display: true,
      showXS: true,
    },
    {
      colNumber: 2,
      colTitle: "Número",
      colName: "document_number",
      orderName: "document_number",
      display: true,
      showXS: false,
    },
    {
      colNumber: 3,
      colTitle: "Monto",
      colName: "totalAmountFormat",
      orderName: "totalAmountFormat",
      display: true,
      showXS: true,
    },
  ];
  return columns;
}


export function resumeCollaboratorsDefaultColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Colaborador",
      colName: "collaboratorLegalName",
      orderName: "collaboratorLegalName",
      display: true,
      showXS: true,
      gridWidth: '1.5fr',
    },
    {
      colNumber: 2,
      colTitle: "Rut",
      colName: "collaboratorLegalIdFormat",
      orderName: "collaboratorLegalIdFormat",
      display: true,
      showXS: false,
      gridWidth: '1.0fr',
    },
    {
      colNumber: 3,
      colTitle: "Monto Total Registrado",
      colName: "totalAmountFormat",
      orderName: "totalAmount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '0.75fr',
    },
    {
      colNumber: 4,
      colTitle: "Monto Total Pagado",
      colName: "totalPayedAmount",
      orderName: "totalPayedAmount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '0.75fr',
    },
    {
      colNumber: 5,
      colTitle: "RutNoFormat",
      colName: "collaboratorLegalId",
      orderName: "collaboratorLegalId",
      hide: true,
      display: false,
      showXS: false,
    },
    {
      colNumber: 6,
      colTitle: "Monto AdeudadoNoFormat",
      colName: "totalAmount",
      orderName: "totalAmount",
      hide: true,
      display: false,
      showXS: false,
    },
  ];
  return columns;
}

export function resumeEmployeesDefaultColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Empleado",
      colName: "employeeLegalName",
      orderName: "employeeLegalName",
      display: true,
      showXS: true,
      gridWidth: '1.5fr',
      editable: true
    },
    {
      colNumber: 2,
      colTitle: "Rut",
      colName: "employeeLegalIdFormat",
      orderName: "employeeLegalIdFormat",
      display: true,
      showXS: false,
      gridWidth: '1.0fr',
    },
    {
      colNumber: 3,
      colTitle: "Último Salario Registrado",
      colName: "lastPaymentAmountFormat",
      orderName: "lastPaymentAmount",
      tooltip: "lastPaymentDateFormat",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '0.75fr',
    },

    {
      colNumber: 4,
      colTitle: "Monto No Conciliado",
      colName: "totalDebtAmountFormat",
      orderName: "totalDebtAmount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '0.75fr',
    },
    {
      colNumber: 5,
      colTitle: "Monto Total Pagado",
      colName: "totalPayedAmountFormat",
      orderName: "totalPayedAmount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '0.75fr',
    },
    {
      colNumber: 6,
      colTitle: "RutNoFormat",
      colName: "employeeLegalId",
      orderName: "employeeLegalId",
      hide: true,
      display: false,
      showXS: false,
    },
    {
      colNumber: 7,
      colTitle: "Monto AdeudadoNoFormat",
      colName: "totalAmount",
      orderName: "totalAmount",
      hide: true,
      display: false,
      showXS: false,
    },
  ];
  return columns;
}

export function employeeAddSalaryDefaultColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Nombre",
      colName: "employeeLegalNameFormat",
      orderName: "employee_legal_name",
      display: true,
      showXS: true,
      gridWidth: '0.75fr',
      editable: true
    },
    {
      colNumber: 2,
      colTitle: "Rut",
      colName: "employeeLegalIdFormat",
      orderName: "employee_legal_id",
      display: true,
      showXS: true,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 3,
      colTitle: "Salario Líquido",
      colName: "employee_net_salary",
      orderName: "employee_net_salary",
      display: true,
      showXS: true,
      gridWidth: '0.75fr',
      editable: true

    },
    {
      colNumber: 4,
      colTitle: "Salario Bruto",
      colName: "employee_gross_salary",
      orderName: "employee_gross_salary",
      display: true,
      showXS: true,
      gridWidth: '0.75fr',
      editable: true
    },
    {
      colNumber: 5,
      colTitle: "Adelanto",
      colName: "employee_advance_salary",
      orderName: "employee_advance_salary",
      display: true,
      showXS: true,
      gridWidth: '0.75fr',
      editable: true
    },

  ];
  return columns;
}

export function employeeDefaultColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Nombre",
      colName: "employeeLegalNameFormat",
      orderName: "employee_legal_name",
      display: true,
      showXS: true,
      gridWidth: '0.75fr',
      editable: true
    },
    {
      colNumber: 2,
      colTitle: "Rut",
      colName: "employeeLegalIdFormat",
      orderName: "employee_legal_id",
      display: true,
      showXS: true,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 3,
      colTitle: "Email",
      colName: "employee_email",
      orderName: "employee_email",
      display: true,
      showXS: true,
      gridWidth: '0.75fr',
      editable: true

    }, {
      colNumber: 4,
      colTitle: "Fecha Inicio Contrato",
      colName: "employeeStartDateFormat",
      orderName: "employee_start_date",
      display: true,
      showXS: true,
      gridWidth: '0.75fr'
    },
  ];
  return columns;
}



export function movementDefaultColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Fecha",
      colName: "movement_date_format",
      orderName: "movement_date",
      display: true,
      showXS: true,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 2,
      colTitle: "Banco",
      colName: "movement_bank_format",
      orderName: "movement_bank_format",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 3,
      colTitle: "Tipo",
      colName: "movement_type_format",
      orderName: "movement_type_format",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 4,
      colTitle: "Cliente/Proveedor",
      colName: "movement_client_provider",
      orderName: "movement_client_provider",
      display: true,
      showXS: false,
      gridWidth: '1.5fr'
    },
    {
      colNumber: 5,
      colTitle: "Descripción",
      colName: "movement_description",
      orderName: "movement_description",
      display: true,
      showXS: false,
      gridWidth: '3fr'
    },
    {
      colNumber: 6,
      colTitle: "Monto Total",
      colName: "movement_total_amount_with_currency",
      orderName: "movement_total_amount",
      display: true,
      showXS: true,
      gridWidth: '1fr',
      align: 'right'
    },
    {
      colNumber: 7,
      colTitle: "Monto Asignado ",
      colName: "movement_assign_format_with_currency",
      orderName: "movement_assign_format",
      display: true,
      showXS: false,
      gridWidth: '1fr',
      align: 'right'
    },
    {
      colNumber: 8,
      colTitle: "Saldo Por Asignar",
      colName: "movement_balance_format_with_currency",
      orderName: "movement_balance",
      display: true,
      showXS: true,
      gridWidth: '1fr',
      align: 'right'
    },
    {
      colNumber: 9,
      colTitle: "Cli/Descripción",
      colName: "movement_description_completed",
      orderName: "movement_description_completed",
      display: false,
      showXS: true,
      gridWidth: '2fr'
    },
  ];
  return columns;
}


export function resumeClientsDefaultColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Cliente",
      colName: "clientLegalName",
      orderName: "clientLegalName",
      display: true,
      showXS: true,
      gridWidth: '1.5fr'
    },
    {
      colNumber: 2,
      colTitle: "Rut",
      colName: "clientLegalIdFormat",
      orderName: "clientLegalIdFormat",
      display: true,
      showXS: false,
      gridWidth: '1.0fr'
    },
    {
      colNumber: 3,
      colTitle: "Documentos Adeudados",
      colName: "totalDebtDocument",
      orderName: "totalDebtDocument",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 4,
      colTitle: "Monto Adeudado",
      colName: "totalDebtAmountFormat",
      orderName: "totalDebtAmount",
      display: true,
      showXS: true,
      gridWidth: '0.75fr',
      align: 'right',
    },
    {
      colNumber: 5,
      colTitle: "Monto > 90 días",
      colName: "totalDebt90AmountFormat",
      orderName: "totalDebt90Amount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '0.75fr'
    },
    {
      colNumber: 6,
      colTitle: "Monto > 60 días",
      colName: "totalDebt60AmountFormat",
      orderName: "totalDebt60Amount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '0.75fr'
    },
    {
      colNumber: 7,
      colTitle: "Monto > 30 días",
      colName: "totalDebt30AmountFormat",
      orderName: "totalDebt30Amount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '0.75fr'
    },
    {
      colNumber: 8,
      colTitle: "Monto < 30 días",
      colName: "totalDebtLess30AmountFormat",
      orderName: "totalDebtLess30Amount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '0.75fr'
    },

    {
      colNumber: 9,
      colTitle: "Monto Pagado",
      colName: "totalPayedAmountFormat",
      orderName: "totalPayedAmount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '0.75fr',
    },
    {
      colNumber: 10,
      colTitle: "Documentos Pagados",
      colName: "totalPayedDocument",
      orderName: "totalPayedDocument",
      hide: true,
      display: false,
      showXS: false,
    },
    {
      colNumber: 11,
      colTitle: "RutNoFormat",
      colName: "clientLegalId",
      orderName: "clientLegalId",
      hide: true,
      display: false,
      showXS: false,
    },
    {
      colNumber: 12,
      colTitle: "Monto AdeudadoNoFormat",
      colName: "totalDebtAmount",
      orderName: "totalDebtAmount",
      display: false,
      hide: true,
      showXS: false,
    },
  ];
  return columns;
}


export function documentColumnsFull() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Fecha",
      colName: "document_date_format",
      orderName: "document_date",
      display: true,
      showXS: true,
    },
    {
      colNumber: 2,
      colTitle: "Tipo",
      colName: "document_type_data",
      orderName: "document_type_data",
      display: true,
      showXS: false,
    },
    {
      colNumber: 3,
      colTitle: "Número",
      colName: "document_number",
      orderName: "document_number",
      display: true,
      showXS: true,
    },
    {
      colNumber: 4,
      colTitle: "Emisor",
      colName: "document_sender_legal_id",
      orderName: "document_sender_legal_id",
      display: true,
      showXS: true,
    },
    {
      colNumber: 5,
      colTitle: "Receptor",
      colName: "document_receiver_legal_id",
      orderName: "document_receiver_legal_id",
      display: true,
      showXS: true,
    },
    {
      colNumber: 6,
      colTitle: "Monto Total",
      colName: "document_total_amount_with_currency",
      orderName: "document_total_amount",
      display: true,
      showXS: true,
    },
    {
      colNumber: 7,
      colTitle: "Monto Asignado ",
      colName: "document_assign_format_with_currency",
      orderName: "document_assign_format",
      display: true,
      showXS: true,
    },
    {
      colNumber: 8,
      colTitle: "Saldo Por Asignar",
      colName: "document_balance_format_with_currency",
      orderName: "document_balance",
      display: true,
      showXS: true,
    },
    {
      colNumber: 9,
      colTitle: "Monto Exento",
      colName: "document_net_amount",
      orderName: "document_net_amount",
      hide: true,
      showXS: true,
    },
    {
      colNumber: 10,
      colTitle: "Monto Impuesto",
      colName: "document_total_tax_amount",
      orderName: "document_total_tax_amount",
      hide: true,
      showXS: true,
    },
    {
      colNumber: 11,
      colTitle: "Fecha Recepción",
      colName: "document_reception_date",
      orderName: "document_reception_date",
      hide: true,
      showXS: true,
    },
    {
      colNumber: 12,
      colTitle: "Estado",
      colName: "document_state",
      orderName: "document_state",
      hide: true,
      showXS: true,
    },
    {
      colNumber: 13,
      colTitle: "Fecha estimada de pago",
      colName: "document_expected_pay_date",
      orderName: "document_expected_pay_date",
      hide: true,
      showXS: true,
    },

  ];
  return columns;
}


export function documentDefaultColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Fecha",
      colName: "document_date_format",
      orderName: "document_date",
      display: true,
      showXS: true,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 2,
      colTitle: "Tipo",
      colName: "document_type_data",
      orderName: "document_type_data",
      display: true,
      showXS: false,
      gridWidth: '1.5fr'
    },
    {
      colNumber: 3,
      colTitle: "Número",
      colName: "document_number",
      orderName: "document_number",
      display: true,
      showXS: false,
      gridWidth: '0.75fr',
      editable: false
    },
    {
      colNumber: 4,
      colTitle: "Emisor/Receptor",
      colName: "document_client_provider",
      orderName: "document_client_provider",
      display: true,
      showXS: false,
      gridWidth: '2fr'
    },
    {
      colNumber: 5,
      colTitle: "Pago Estimado",
      colName: "document_expected_pay_date_format",
      orderName: "document_expected_pay_date",
      display: true,
      showXS: false,
      gridWidth: '1fr',
      editable: true
    },

    {
      colNumber: 6,
      colTitle: "Monto Total",
      colName: "document_total_amount_with_currency",
      orderName: "document_total_amount",
      display: true,
      showXS: true,
      gridWidth: '1.5fr',
      align: 'right'
    },
    {
      colNumber: 7,
      colTitle: "Monto Asignado ",
      colName: "document_assign_format_with_currency",
      orderName: "document_assign_format",
      display: true,
      showXS: false,
      gridWidth: '1.5fr',
      align: 'right'
    },
    {
      colNumber: 8,
      colTitle: "Saldo Por Asignar",
      colName: "document_balance_format_with_currency",
      orderName: "document_balance",
      display: true,
      showXS: true,
      gridWidth: '1.5fr',
      align: 'right'
    },
    {
      colNumber: 9,
      colTitle: "Cli/Descripción",
      colName: "document_description_completed",
      orderName: "document_description_completed",
      hide: true,
      showXS: true,
      gridWidth: '1.5fr'
    },
  ];
  return columns;
}

export function documentClientColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Fecha",
      colName: "document_date_format",
      orderName: "document_date",
      display: true,
      showXS: true,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 2,
      colTitle: "Tipo",
      colName: "document_type_data",
      orderName: "document_type_data",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 3,
      colTitle: "Emitido/Recibido",
      colName: "document_sender_receiver",
      orderName: "document_sender_receiver",
      display: true,
      showXS: false,
      gridWidth: '1.25fr'
    },
    {
      colNumber: 4,
      colTitle: "Número",
      colName: "document_number",
      orderName: "document_number",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 5,
      colTitle: "Emisor/Receptor",
      colName: "document_enterprise_name",
      orderName: "document_enterprise_name",
      display: true,
      showXS: false,
      gridWidth: '2fr'
    },
    {
      colNumber: 6,
      colTitle: "Monto Total",
      colName: "document_total_amount_with_currency",
      orderName: "document_total_amount",
      display: true,
      showXS: true,
      gridWidth: '1.5fr',
      align: 'right'
    },
    {
      colNumber: 7,
      colTitle: "Monto Asignado ",
      colName: "document_assign_format_with_currency",
      orderName: "document_assign_format",
      display: true,
      showXS: false,
      gridWidth: '1.5fr',
      align: 'right'
    },
    {
      colNumber: 8,
      colTitle: "Saldo Por Asignar",
      colName: "document_balance_format_with_currency",
      orderName: "document_balance",
      display: true,
      showXS: true,
      gridWidth: '1.5fr',
      align: 'right'
    },
    {
      colNumber: 9,
      colTitle: "Cli/Descripción",
      colName: "document_description_completed",
      orderName: "document_description_completed",
      hide: true,
      showXS: true,
      gridWidth: '1.5fr'
    },
  ];
  return columns;
}


export function documentProviderColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Fecha",
      colName: "document_date_format",
      orderName: "document_date",
      display: true,
      showXS: true,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 2,
      colTitle: "Tipo",
      colName: "document_type_data",
      orderName: "document_type_data",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 3,
      colTitle: "Emitido/Recibido",
      colName: "document_sender_receiver",
      orderName: "document_sender_receiver",
      display: true,
      showXS: false,
      gridWidth: '1.25fr'
    },
    {
      colNumber: 4,
      colTitle: "Número",
      colName: "document_number",
      orderName: "document_number",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 5,
      colTitle: "Emisor/Receptor",
      colName: "document_enterprise_name",
      orderName: "document_enterprise_name",
      display: true,
      showXS: false,
      gridWidth: '2fr'
    },
    {
      colNumber: 6,
      colTitle: "Monto Total",
      colName: "document_total_amount_with_currency",
      orderName: "document_total_amount",
      display: true,
      showXS: true,
      gridWidth: '1.2fr',
      align: 'right'
    },
    {
      colNumber: 7,
      colTitle: "Monto Asignado ",
      colName: "document_assign_format_with_currency",
      orderName: "document_assign_format",
      display: true,
      showXS: false,
      gridWidth: '1.2fr',
      align: 'right'
    },
    {
      colNumber: 8,
      colTitle: "Saldo Por Asignar",
      colName: "document_balance_format_with_currency",
      orderName: "document_balance",
      display: true,
      showXS: true,
      gridWidth: '1.2fr',
      align: 'right'
    },
    {
      colNumber: 9,
      colTitle: "Cli/Descripción",
      colName: "document_description_completed",
      orderName: "document_description_completed",
      hide: true,
      showXS: true,
      gridWidth: '1.5fr'
    },
  ];
  return columns;
}

export function documentCollaboratorColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Fecha",
      colName: "document_date_format",
      orderName: "document_date",
      display: true,
      showXS: true,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 2,
      colTitle: "Tipo",
      colName: "document_type_data",
      orderName: "document_type_data",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 3,
      colTitle: "Emitido/Recibido",
      colName: "document_sender_receiver",
      orderName: "document_sender_receiver",
      display: true,
      showXS: false,
      gridWidth: '1.25fr'
    },
    {
      colNumber: 4,
      colTitle: "Número",
      colName: "document_number",
      orderName: "document_number",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 5,
      colTitle: "Emisor/Receptor",
      colName: "document_enterprise_name",
      orderName: "document_enterprise_name",
      display: true,
      showXS: false,
      gridWidth: '2fr'
    },
    {
      colNumber: 6,
      colTitle: "Monto Total",
      colName: "document_total_amount_with_currency",
      orderName: "document_total_amount",
      display: true,
      showXS: true,
      gridWidth: '1.5fr',
      align: 'right'
    },
    {
      colNumber: 7,
      colTitle: "Monto Asignado ",
      colName: "document_assign_format_with_currency",
      orderName: "document_assign_format",
      display: true,
      showXS: false,
      gridWidth: '1.5fr',
      align: 'right'
    },
    {
      colNumber: 8,
      colTitle: "Saldo Por Asignar",
      colName: "document_balance_format_with_currency",
      orderName: "document_balance",
      display: true,
      showXS: true,
      gridWidth: '1.5fr',
      align: 'right'
    },
    {
      colNumber: 9,
      colTitle: "Cli/Descripción",
      colName: "document_description_completed",
      orderName: "document_description_completed",
      hide: true,
      showXS: true,
      gridWidth: '1.5fr'
    },
  ];
  return columns;
}


export function documentEmployeeColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Fecha",
      colName: "document_date_format",
      orderName: "document_date",
      display: true,
      showXS: true,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 2,
      colTitle: "Tipo",
      colName: "document_type_data",
      orderName: "document_type_data",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 3,
      colTitle: "Emitido/Recibido",
      colName: "document_enterprise_name",
      orderName: "document_enterprise_name",
      display: true,
      showXS: false,
      gridWidth: '1.25fr'
    },
    {
      colNumber: 4,
      colTitle: "Número",
      colName: "document_number",
      orderName: "document_number",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 5,
      colTitle: "Comentarios",
      colName: "document_comment",
      orderName: "document_comment",
      display: true,
      showXS: false,
      gridWidth: '2fr'
    },
    {
      colNumber: 6,
      colTitle: "Monto Total",
      colName: "document_total_amount_with_currency",
      orderName: "document_total_amount",
      display: true,
      showXS: true,
      gridWidth: '1.5fr',
      align: 'right'
    },
    {
      colNumber: 7,
      colTitle: "Monto Asignado ",
      colName: "document_assign_format_with_currency",
      orderName: "document_assign_format",
      display: true,
      showXS: false,
      gridWidth: '1.5fr',
      align: 'right'
    },
    {
      colNumber: 8,
      colTitle: "Saldo Por Asignar",
      colName: "document_balance_format_with_currency",
      orderName: "document_balance",
      display: true,
      showXS: true,
      gridWidth: '1.5fr',
      align: 'right'
    },
    {
      colNumber: 9,
      colTitle: "Cli/Descripción",
      colName: "document_description_completed",
      orderName: "document_description_completed",
      hide: true,
      showXS: true,
      gridWidth: '1.5fr'
    },
  ];
  return columns;
}


export function matchDocumentDefaultColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Fecha",
      colName: "document_date_format",
      orderName: "document_date",
      display: true,
      showXS: true,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 2,
      colTitle: "Tipo",
      colName: "document_type_data",
      orderName: "document_type_data",
      display: true,
      showXS: false,
      gridWidth: '1fr'
    },
    {
      colNumber: 3,
      colTitle: "Número",
      colName: "document_business_number",
      orderName: "document_business_number",
      display: true,
      showXS: true,
      gridWidth: '1fr'
    },
    {
      colNumber: 4,
      colTitle: "Emisor/Receptor",
      colName: "document_client_provider",
      orderName: "document_client_provider",
      display: true,
      showXS: false,
      gridWidth: '1.5fr'
    },
    {
      colNumber: 5,
      colTitle: "Descripción",
      colName: "document_description",
      orderName: "document_description",
      hide: true,
      hideXS: true,
      gridWidth: '1.5fr'
    },
    {
      colNumber: 6,
      colTitle: "Monto Total",
      colName: "document_total_amount_with_currency",
      orderName: "document_total_amount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '1fr'
    },
    {
      colNumber: 7,
      colTitle: "Monto Asignado ",
      colName: "document_assign_format_with_currency",
      orderName: "document_assign_format",
      display: true,
      showXS: false,
      align: 'right',
      gridWidth: '1fr'
    },
    {
      colNumber: 8,
      colTitle: "Saldo Por Asignar",
      colName: "document_balance_format_with_currency",
      orderName: "document_balance",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '1fr'
    },
  ];
  return columns;
}

export function reconciliationDefaultColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Fecha",
      colName: "reconciliation_reference_date_format",
      orderName: "reconciliation_reference_date",
      display: true,
      showXS: true,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 2,
      colTitle: "Tipo",
      colName: "reconciliation_reference_type_format",
      orderName: "reconciliation_reference_type_format",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 3,
      colTitle: "Emisor/Receptor",
      colName: "reconciliation_reference_sender_receiver",
      orderName: "reconciliation_reference_sender_receiver",
      display: true,
      showXS: false,
      gridWidth: '1.5fr'
    },
    {
      colNumber: 4,
      colTitle: "Descripción",
      colName: "reconciliation_reference_description",
      orderName: "reconciliation_reference_description",
      display: false,
      showXS: false,
      gridWidth: '1.5fr'
    },
    {
      colNumber: 5,
      colTitle: "Número/Info",
      colName: "reconciliation_reference_businessNumber_format",
      orderName: "reconciliation_reference_businessNumber_format",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 6,
      colTitle: "Monto Total",
      colName: "reconciliation_reference_total_amount_with_currency",
      orderName: "reconciliation_reference_amount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '1fr'

    },
    {
      colNumber: 7,
      colTitle: "Monto Asignado ",
      colName: "reconciliation_reference_assign_format_with_currency",
      orderName: "reconciliation_reference_assign_format",
      display: true,
      showXS: false,
      align: 'right',
      gridWidth: '1fr'

    },
    {
      colNumber: 9,
      colTitle: "Cli/Descripción",
      colName: "reconciliation_reference_description_completed",
      orderName: "reconciliation_reference_description_completed",
      display: false,
      showXS: true,
      gridWidth: '1.5fr'
    },



  ];
  return columns;
}

export function reconciliationDocumentDefaultColumns() {
  const columns = [
    {
      colNumber: 1,
      colTitle: "Fecha",
      colName: "reconciliation_reference_date_format",
      orderName: "reconciliation_reference_date",
      display: true,
      showXS: true,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 2,
      colTitle: "Tipo",
      colName: "reconciliation_reference_type_format",
      orderName: "reconciliation_reference_type_format",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 3,
      colTitle: "Emisor/Receptor",
      colName: "reconciliation_reference_sender_receiver",
      orderName: "reconciliation_reference_sender_receiver",
      display: false,
      showXS: false,
      gridWidth: '1.5fr'
    },
    {
      colNumber: 4,
      colTitle: "Descripción",
      colName: "reconciliation_reference_description",
      orderName: "reconciliation_reference_description",
      display: true,
      showXS: false,
      gridWidth: '1.5fr'
    },
    {
      colNumber: 5,
      colTitle: "Número",
      colName: "reconciliation_reference_businessNumber_format",
      orderName: "reconciliation_reference_businessNumber_format",
      display: true,
      showXS: false,
      gridWidth: '0.75fr'
    },
    {
      colNumber: 6,
      colTitle: "Monto Total",
      colName: "reconciliation_reference_total_amount_with_currency",
      orderName: "reconciliation_reference_amount",
      display: true,
      showXS: true,
      align: 'right',
      gridWidth: '1fr'

    },
    {
      colNumber: 7,
      colTitle: "Monto Asignado ",
      colName: "reconciliation_reference_assign_format_with_currency",
      orderName: "reconciliation_reference_assign_format",
      display: true,
      showXS: false,
      align: 'right',
      gridWidth: '1fr'

    },
    {
      colNumber: 9,
      colTitle: "Cli/Descripción",
      colName: "reconciliation_reference_description_completed",
      orderName: "reconciliation_reference_description_completed",
      display: false,
      showXS: true,
      gridWidth: '1.5fr'
    },



  ];
  return columns;
}


/**
 * Evalúa si una condición se cumple para un valor dado.
 * Esta es una función simplificada y puede necesitar ser extendida para condiciones más complejas.
 * Maneja condiciones numéricas (>, >=, <, <=) y de igualdad/desigualdad (===, !==, ==, !=).
 * También maneja literales como 'null', 'true', 'false' y strings entrecomillados.
 * @param actualValue - El valor actual del campo del movimiento.
 * @param conditionStr - La cadena de condición (ej: ">0", "==='pending'", "!==null").
 * @returns true si la condición se cumple, false en caso contrario.
 */
/**
 * Evalúa si una condición se cumple para un valor dado, considerando el contexto del movimiento completo.
 * @param actualValue - El valor actual del campo primario del movimiento.
 * @param conditionStr - La cadena de condición (ej: ">0", "==='pending'", "===[otherField]").
 * @param movementContext - El objeto movimiento completo, para comparaciones entre campos.
 * @returns true si la condición se cumple, false en caso contrario.
 */
function evaluateCondition(actualValue, conditionStr, movementContext) {

  //console.log("conditionStr: " +  conditionStr);
  //console.log("typeof conditionStr: " + typeof conditionStr +  " actual" + actualValue);
  if (typeof conditionStr === 'boolean') {
    if (actualValue === conditionStr) {
      return true;
    }
  } else {
    if (conditionStr?.toLowerCase() === 'alwaystrue') {
      return true;
    }
    // Verificar si el valor actual es nulo o indefinido
    // Primero, verificar si es una comparación entre campos (ej: "===[fieldName]", "!==[fieldName]")
    const fieldComparisonMatch = conditionStr.match(/^(===|!==|==|!=)\s*\[([a-zA-Z0-9_]+)\]$/);
    if (fieldComparisonMatch) {
      const [, operator, field2NameStr] = fieldComparisonMatch;
      const field2Name = field2NameStr; // Asumimos que field2Name es una clave válida de Movement


      if (!(field2Name in movementContext)) {
        console.warn(`[evaluateCondition] El campo de comparación '${field2Name}' no existe en el objeto movimiento.`);
        return false;
      }
      const valueFromField2 = movementContext[field2Name];

      switch (operator) {
        case '===': return actualValue === valueFromField2;
        case '!==': return actualValue !== valueFromField2;
        // eslint-disable-next-line eqeqeq
        case '==': return actualValue == valueFromField2;
        // eslint-disable-next-line eqeqeq
        case '!=': return actualValue != valueFromField2;
        case '!=abs': return actualValue != Math.abs(valueFromField2);
      }
    }

    // Si no es una comparación entre campos, proceder con la lógica existente
    // Condición para verificar existencia (no nulo ni indefinido)
    if (conditionStr.toLowerCase() === 'exists' || conditionStr.toLowerCase() === '!==null') {
      return actualValue !== null && actualValue !== undefined;
    }
    // Condición para verificar no existencia (nulo o indefinido)
    if (conditionStr.toLowerCase() === 'notexists' || conditionStr.toLowerCase() === '===null') {
      return actualValue === null || actualValue === undefined;
    }

    const numericMatch = conditionStr.match(/^(>|>=|<|<=)\s*(-?\d+(\.\d+)?)$/);
    if (numericMatch) {
      const [, operator, valueStr] = numericMatch;
      const valueToCompare = parseFloat(valueStr);
      if (typeof actualValue !== 'number') {
        console.warn(`[evaluateCondition] Attempting numeric comparison on non-numeric value: ${actualValue} with condition ${conditionStr}`);
        return false;
      }
      switch (operator) {
        case '>': return actualValue > valueToCompare;
        case '>=': return actualValue >= valueToCompare;
        case '<': return actualValue < valueToCompare;
        case '<=': return actualValue <= valueToCompare;
      }
    }

    const equalityMatch = conditionStr.match(/^(===|!==|==|!=)\s*(.*)$/);
    if (equalityMatch) {
      const [, operator, valueStr] = equalityMatch;
      let valueToCompare;

      if (valueStr.toLowerCase() === 'null') {
        valueToCompare = null;
      } else if (valueStr.toLowerCase() === 'true') {
        valueToCompare = true;
      } else if (valueStr.toLowerCase() === 'false') {
        valueToCompare = false;
      } else if ((valueStr.startsWith("'") && valueStr.endsWith("'")) || (valueStr.startsWith('"') && valueStr.endsWith('"'))) {
        valueToCompare = valueStr.slice(1, -1);
      } else if (!isNaN(parseFloat(valueStr)) && isFinite(Number(valueStr))) {
        if (typeof actualValue === 'number' && operator.includes('=')) {
          valueToCompare = parseFloat(valueStr);
        } else {
          valueToCompare = valueStr;
        }
      } else {
        valueToCompare = valueStr;
      }

      switch (operator) {
        case '===': return actualValue === valueToCompare;
        case '!==': return actualValue !== valueToCompare;
        // eslint-disable-next-line eqeqeq
        case '==': return actualValue == valueToCompare;
        // eslint-disable-next-line eqeqeq
        case '!=': return actualValue != valueToCompare;
      }
    }

    console.warn(`[evaluateCondition] Condición no manejada o inválida: "${conditionStr}" para el valor:`, actualValue);
    return false;
  }


}
/**
 * Determina si un botón específico debe mostrarse para un movimiento dado,
 * basándose en su definición de condición.
 * @param movement - El objeto movimiento.
 * @param definition - La definición del botón.
 * @returns true si el botón debe mostrarse, false en caso contrario.
 */
export function shouldShowButton(object, definition, definition2, definition3) {
  const actualValue = getFieldValue(object, definition.field);

  //console.log("actualValue:" + actualValue);
  //console.log("definition.condition:" + definition.condition);
  //console.log("object:" + JSON.stringify(object));

  const condition1Met = evaluateCondition(actualValue, definition.condition, object);
  //console.log("condition1Met:" + condition1Met);

  if (!condition1Met) {
    return false; // Si la condición del primer botón no se cumple, no mostramos el botón
  }
  //  console.log("--------->" + definition3);
  if (definition3) {
    //console.log("---------> tiene definition3" );
    const actualValue3 = getFieldValue(object, definition3.field);
    return evaluateCondition(actualValue3, definition3.condition, object);

    //const actualValue2 = getFieldValue(object, definition2.field);
    //return evaluateCondition(actualValue2, definition2.condition, object);
  }
  if (definition2) {
    //console.log("---------> tiene definition2: " + definition2.field ); 
    //console.log("---------> object" + JSON.stringify(object) ); 
    const actualValue2 = getFieldValue(object, definition2.field);
    //console.log("---------> actualValue2" + JSON.stringify(actualValue2) ); 
    return evaluateCondition(actualValue2, definition2.condition, object);
  }

  // Si no hay definición2, solo evaluamos la condición del botón
  return true;
}


/**
 * Obtiene el valor de un campo específico de un objeto Movement.
 * @param movement - El objeto movimiento.
 * @param field - El nombre del campo (debe ser una clave válida de Movement).
 * @returns El valor del campo.
 */
export function getFieldValue(object, field) {
  return object[field];
}


export function formatClientDebtDataYearMonth(dataArray) {
  const formattedObject = {};

  dataArray.forEach(item => {
    // 1. Formatea la clave 'monthYear'
    // Asegura que el mes tenga 2 dígitos (ej. 6 -> '06')
    const month = String(item.month).padStart(2, '0');
    const year = String(item.year);
    const monthYearKey = `${year}${month}`;

    // 2. Convierte los valores de string a número

    const totalDebt = parseInt(item.total_debt, 10);
    const totalDebt90 = parseInt(item.total_debt_90, 10);
    const totalDebt60 = parseInt(item.total_debt_60, 10);
    const totalDebt30 = parseInt(item.total_debt_30, 10);
    const totalDebtLess30 = parseInt(item.total_debt_less_30, 10);
    const totalPayed = parseInt(item.total_payed, 10);

    // 4. Asigna los valores al nuevo objeto
    formattedObject[monthYearKey] = {
      totalDebt,
      totalDebt90,
      totalDebt60,
      totalDebt30,
      totalDebtLess30,
      totalPayed,
    };
  });

  return formattedObject;
}



export function formatClientDebtData(dataArray) {

  const formattedObject = {};

  dataArray?.forEach(item => {
    // 1. Formatea la clave 'monthYear'
    // Asegura que el mes tenga 2 dígitos (ej. 6 -> '06')

    const year = String(item.year);
    const yearKey = `${year}`;

    //2. Agrupa los datos por año
    if (!formattedObject[yearKey]) {
      formattedObject[yearKey] = {
        totalDebt: parseInt(item.total_debt, 10),
        totalDebt90: parseInt(item.total_debt_90, 10),
        totalDebt60: parseInt(item.total_debt_60, 10),
        totalDebt30: parseInt(item.total_debt_30, 10),
        totalDebtLess30: parseInt(item.total_debt_less_30, 10),
        totalPayed: parseInt(item.total_payed, 10)
      };
    } else {

      //       console.log("AÑOS IGUALES: " + yearKey + " item: " + JSON.stringify(item) + "\n");
      //        console.log(" formattedObject[yearKey]: " + JSON.stringify(formattedObject[yearKey]) + "\n");
      //console.log(" formattedObject[yearKey].totalDebt: " + JSON.stringify(formattedObject[yearKey].totalDebt) + "\n");

      formattedObject[yearKey] = {
        totalDebt: parseInt(item.total_debt, 10) + (formattedObject[yearKey].totalDebt ?? 0),
        totalDebt90: parseInt(item.total_debt_90, 10) + (formattedObject[yearKey].totalDebt90 ?? 0),
        totalDebt60: parseInt(item.total_debt_60, 10) + (formattedObject[yearKey].totalDebt60 ?? 0),
        totalDebt30: parseInt(item.total_debt_30, 10) + (formattedObject[yearKey].totalDebt30 ?? 0),
        totalDebtLess30: parseInt(item.total_debt_less_30, 10) + (formattedObject[yearKey].totalDebtLess30 ?? 0),
        totalPayed: parseInt(item.total_payed, 10) + (formattedObject[yearKey].totalPayed ?? 0)
      };
    }

    // 4. Asigna los valores al nuevo objeto y retorna


  });

  return formattedObject;
}


export function formatProviderCredData(dataArray) {
  console.log("dataArray:" + JSON.stringify(dataArray));
  const formattedObject = {};

  dataArray?.forEach(item => {
    // 1. Formatea la clave 'monthYear'
    // Asegura que el mes tenga 2 dígitos (ej. 6 -> '06')

    const year = String(item.year);
    const yearKey = `${year}`;

    //2. Agrupa los datos por año
    if (!formattedObject[yearKey]) {
      formattedObject[yearKey] = {
        totalCred: parseInt(item.total_cred, 10),
        totalCred90: parseInt(item.total_cred_90, 10),
        totalCred60: parseInt(item.total_cred_60, 10),
        totalCred30: parseInt(item.total_cred_30, 10),
        totalCredLess30: parseInt(item.total_cred_less_30, 10),
        totalPayed: parseInt(item.total_payed, 10)
      };
    } else {

      //       console.log("AÑOS IGUALES: " + yearKey + " item: " + JSON.stringify(item) + "\n");
      //        console.log(" formattedObject[yearKey]: " + JSON.stringify(formattedObject[yearKey]) + "\n");
      //console.log(" formattedObject[yearKey].totalDebt: " + JSON.stringify(formattedObject[yearKey].totalDebt) + "\n");

      formattedObject[yearKey] = {
        totalCred: parseInt(item.total_cred, 10) + (formattedObject[yearKey].totalCred ?? 0),
        totalCred90: parseInt(item.total_cred_90, 10) + (formattedObject[yearKey].totalCred90 ?? 0),
        totalCred60: parseInt(item.total_cred_60, 10) + (formattedObject[yearKey].totalCred60 ?? 0),
        totalCred30: parseInt(item.total_cred_30, 10) + (formattedObject[yearKey].totalCred30 ?? 0),
        totalCredLess30: parseInt(item.total_cred_less_30, 10) + (formattedObject[yearKey].totalCredLess30 ?? 0),
        totalPayed: parseInt(item.total_payed, 10) + (formattedObject[yearKey].totalPayed ?? 0)
      };
    }

    // 4. Asigna los valores al nuevo objeto y retorna


  });

  return formattedObject;
}


export function formatClientDebtAllData(dataArray) {
  // 1. Inicializa el objeto que acumulará la suma total de todos los campos.
  const totalSums = {
    totalDebt: 0,
    totalDebt90: 0,
    totalDebt60: 0,
    totalDebt30: 0,
    totalDebtLess30: 0,
    totalPayed: 0,
  };

  // Verificación para el caso de array nulo o vacío
  if (!dataArray || dataArray.length === 0) {
    return totalSums;
  }

  dataArray.forEach(item => {
    // 2. Suma los valores de cada campo del elemento actual al acumulador.
    // Usamos '?? 0' para asegurar que si el valor del item es nulo/undefined, 
    // se trate como 0 antes de sumar.

    totalSums.totalDebt += parseInt(item.total_debt, 10) ?? 0;
    totalSums.totalDebt90 += parseInt(item.total_debt_90, 10) ?? 0;
    totalSums.totalDebt60 += parseInt(item.total_debt_60, 10) ?? 0;
    totalSums.totalDebt30 += parseInt(item.total_debt_30, 10) ?? 0;
    totalSums.totalDebtLess30 += parseInt(item.total_debt_less_30, 10) ?? 0;
    totalSums.totalPayed += parseInt(item.total_payed, 10) ?? 0;
  });

  // 3. Retorna el objeto único con la suma total.
  return totalSums;
}



export function formatProviderCredAllData(dataArray) {
  // 1. Inicializa el objeto que acumulará la suma total de todos los campos.
  const totalSums = {
    totalCred: 0,
    totalCred90: 0,
    totalCred60: 0,
    totalCred30: 0,
    totalCredLess30: 0,
    totalPayed: 0,
  };

  // Verificación para el caso de array nulo o vacío
  if (!dataArray || dataArray.length === 0) {
    return totalSums;
  }

  dataArray.forEach(item => {
    // 2. Suma los valores de cada campo del elemento actual al acumulador.
    // Usamos '?? 0' para asegurar que si el valor del item es nulo/undefined, 
    // se trate como 0 antes de sumar.

    totalSums.totalCred += parseInt(item.total_cred, 10) ?? 0;
    totalSums.totalCred90 += parseInt(item.total_cred_90, 10) ?? 0;
    totalSums.totalCred60 += parseInt(item.total_cred_60, 10) ?? 0;
    totalSums.totalCred30 += parseInt(item.total_cred_30, 10) ?? 0;
    totalSums.totalCredLess30 += parseInt(item.total_cred_less_30, 10) ?? 0;
    totalSums.totalPayed += parseInt(item.total_payed, 10) ?? 0;
  });

  // 3. Retorna el objeto único con la suma total.
  return totalSums;
}

export function filterAndGroupExpenses(data, targetCurrency, targetTypes) {
  const allowedTypes = new Set(targetTypes);
  const result = {};

  // 1. Iterar sobre las claves YYYYMM (Mes/Año)
  for (const yyyymm in data) {
    if (data.hasOwnProperty(yyyymm)) {
      const typesInMonth = data[yyyymm];
      let monthHasData = false;
      const currentMonthData = {};

      // 2. Iterar sobre los tipos de gasto (expenseType)
      for (const expenseType in typesInMonth) {
        if (typesInMonth.hasOwnProperty(expenseType)) {

          // Condición 1: Verificar si el tipo de gasto está en la lista deseada
          if (allowedTypes.has(expenseType)) {

            const currencies = typesInMonth[expenseType];

            // Condición 2: Verificar si existe el dato para la moneda deseada
            if (currencies.hasOwnProperty(targetCurrency)) {

              // Si pasa ambos filtros, agregamos los detalles al resultado
              currentMonthData[expenseType] = currencies[targetCurrency];
              monthHasData = true;
            }
          }
        }
      }

      // 3. Si se encontraron datos en el mes, agregarlos al resultado final
      if (monthHasData) {
        result[yyyymm] = currentMonthData;
      }
    }
  }

  return result;


}


export function formatExpenseEmployeeDataYearMonth(dataArray) {
  const formattedObject = {};

  dataArray?.forEach(item => {
    // 1. Formatea la clave 'monthYear'
    // Asegura que el mes tenga 2 dígitos (ej. 6 -> '06')
    const month = String(item.expense_month).padStart(2, '0');
    const year = String(item.expense_year);
    const monthYearKey = `${year}${month}`;

    // 2. Convierte los valores de string a número
    const quantity = parseInt(item.quantity, 10);
    const reconciliations = parseInt(item.reconciliations, 10);
    const partials = parseInt(item.partials, 10);
    const amount = parseInt(item.total_amount_per_month, 10);
    const registries = parseInt(item.expense_registries, 10);
    const type = item.expense_type ?? 'CLP';
    const currency = item.expense_currency;
    console.log("type:" + type);
    console.log("monthYear:" + monthYearKey);
    // 3. Calcula los valores de 'pending' y 'percentage'
    const pending = quantity - reconciliations;
    const percentage = quantity > 0 ? ((reconciliations / quantity) * 100).toFixed(1) + '%' : '0%';
    console.log("pending:" + pending);
    console.log("type:" + type);

    if (!formattedObject[monthYearKey]) {
      formattedObject[monthYearKey] = {};
    }
    if (!formattedObject[monthYearKey][type]) {
      console.log("ok");
      formattedObject[monthYearKey][type] = {};
    }
    console.log("percentage:" + percentage);

    // 4. Asigna los valores al nuevo objeto
    formattedObject[monthYearKey][type][currency] = {
      registries,
      amount,
      quantity,
      reconciliations,
      partials,
      pending,
      percentage,
    }

  });

  console.log("\nformattedObject:" + JSON.stringify(formattedObject));
  return formattedObject;
}

export function formatMovementDataYearMonth(dataArray) {
  const formattedObject = {};

  dataArray.forEach(item => {
    // 1. Formatea la clave 'monthYear'
    // Asegura que el mes tenga 2 dígitos (ej. 6 -> '06')
    const month = String(item.movement_month).padStart(2, '0');
    const year = String(item.movement_year);
    const monthYearKey = `${year}${month}`;

    // 2. Convierte los valores de string a número
    const quantity = parseInt(item.quantity, 10);
    const reconciliations = parseInt(item.reconciliations, 10);
    const partials = parseInt(item.partials, 10);

    // 3. Calcula los valores de 'pending' y 'percentage'
    const pending = quantity - reconciliations;
    const percentage = quantity > 0 ? ((reconciliations / quantity) * 100).toFixed(1) + '%' : '0%';

    // 4. Asigna los valores al nuevo objeto
    formattedObject[monthYearKey] = {
      quantity,
      reconciliations,
      partials,
      pending,
      percentage,
    };
  });

  return formattedObject;
}
/*
export function formatMovementDataYearMonth(dataArray) {
  const formattedObject = {};

  dataArray.forEach(item => {
    // 1. Formatea la clave 'monthYear'
    // Asegura que el mes tenga 2 dígitos (ej. 6 -> '06')

    const year = String(item.year);
    const yearKey = `${year}`;

    //2. Agrupa los datos por año
    if (!formattedObject[yearKey]) {
      formattedObject[yearKey] = {};
    } else {
      formattedObject[yearKey] = {
        totalDebt: parseInt(item.total_debt, 10) + formattedObject[yearKey].totalDebt,
        totalDebt90: parseInt(item.total_debt_90, 10) + formattedObject[yearKey].totalDebt90,
        totalDebt60: parseInt(item.total_debt_60, 10) + formattedObject[yearKey].totalDebt60,
        totalDebt30: parseInt(item.total_debt_30, 10) + formattedObject[yearKey].totalDebt30,
        totalDebtLess30: parseInt(item.total_debt_less_30, 10) + formattedObject[yearKey].totalDebtLess30,
        totalPayed: parseInt(item.total_payed, 10) + formattedObject[yearKey].totalPayed
      };
    }

    // 4. Asigna los valores al nuevo objeto y retorna


  });

  return formattedObject;
}
*/


export function formatEmployeeData(data) {
  let formattedObject = {};

  // 1. Formatea la clave 'monthYear'
  // Asegura que el mes tenga 2 dígitos (ej. 6 -> '06')

  // 2. Convierte los valores de string a número
  for (let i = 0; i < data?.length; i++) {
    const quantity = parseInt(data[i]?.quantity, 10);
    const reconciliations = parseInt(data[i]?.reconciliations, 10);
    const partials = parseInt(data[i]?.partials, 10);
    const amount = parseInt(data[i]?.total_amount, 10);
    const registries = parseInt(data[i]?.registries, 10);
    // 3. Calcula los valores de 'pending' y 'percentage'
    const pending = quantity - reconciliations;
    const percentage = quantity > 0 ? ((reconciliations / quantity) * 100).toFixed(1) + '%' : '0%';
    const type = data[i].type;
    // 4. Asigna los valores al nuevo objeto
    formattedObject[type] = {
      amount,
      quantity,
      registries,
      reconciliations,
      partials,
      pending,
      percentage,
    };

    console.log("formattedObject: " + JSON.stringify(formattedObject));
  }

  return formattedObject;
}


export function formatMovementData(data) {
  let formattedObject = {};

  // 1. Formatea la clave 'monthYear'
  // Asegura que el mes tenga 2 dígitos (ej. 6 -> '06')

  // 2. Convierte los valores de string a número
  const quantity = parseInt(data.quantity, 10);
  const reconciliations = parseInt(data.reconciliations, 10);
  const partials = parseInt(data.partials, 10);

  // 3. Calcula los valores de 'pending' y 'percentage'
  const pending = quantity - reconciliations;
  const percentage = quantity > 0 ? ((reconciliations / quantity) * 100).toFixed(1) + '%' : '0%';

  // 4. Asigna los valores al nuevo objeto
  formattedObject = {
    quantity,
    reconciliations,
    partials,
    pending,
    percentage,
  };


  return formattedObject;
}


export function formatMovementDataYear(dataArray) {

  const transformedData = dataArray?.reduce((acc, curr) => {
    const year = curr.movement_year;

    // 1. Si el año no existe en el acumulador, lo inicializamos con los contadores en 0
    if (!acc[year]) {
      acc[year] = {
        quantity: 0,
        reconciliations: 0,
        partials: 0,
        pending: 0,
        percentage: 0,
        incomes: {
          quantity: 0,
          amount: 0,
        },
        outcomes: {
          quantity: 0,
          amount: 0,
        },
      };
    }

    // 2. Agregamos el objeto específico del tipo (invoice, bill, expense)
    // Extraemos solo las propiedades que te interesan para el sub-objeto


    // 3. Sumamos los valores a los totales del año
    acc[year].quantity += curr.quantity;
    acc[year].reconciliations += curr.reconciliations;
    acc[year].partials += curr.partials;
    acc[year].pending = acc[year].quantity - acc[year].reconciliations;
    acc[year].percentage = acc[year].quantity > 0 ? ((acc[year].reconciliations / acc[year].quantity) * 100).toFixed(1) + '%' : '0%';
    acc[year].incomes.quantity += curr.incomes;
    acc[year].incomes.amount += curr.total_incomes;
    acc[year].outcomes.quantity += curr.outcomes;
    acc[year].outcomes.amount += curr.total_outcomes;


    return acc;
  }, {});

  return transformedData;
}


export function formatDocumentDataYearMonth(dataArray) {
  const formattedObject = {};

  dataArray?.forEach(item => {
    // 1. Formatea la clave 'monthYear'
    // Asegura que el mes tenga 2 dígitos (ej. 6 -> '06')
    const month = String(item.document_month).padStart(2, '0');
    const year = String(item.document_year);
    const monthYearKey = `${year}${month}`;

    // 2. Convierte los valores de string a número
    const quantity = parseInt(item.quantity, 10);
    const reconciliations = parseInt(item.reconciliations, 10);
    const partials = parseInt(item.partials, 10);

    // 3. Calcula los valores de 'pending' y 'percentage'
    const pending = quantity - reconciliations;
    const percentage = quantity > 0 ? ((reconciliations / quantity) * 100).toFixed(1) + '%' : '0%';

    // 4. Asigna los valores al nuevo objeto
    formattedObject[monthYearKey] = {
      quantity,
      reconciliations,
      partials,
      pending,
      percentage,
    };
  });

  return formattedObject;
}


export function formatDocumentDataYear(dataArray) {

  const transformedData = dataArray?.reduce((acc, curr) => {
    const year = curr.document_year;

    // 1. Si el año no existe en el acumulador, lo inicializamos con los contadores en 0
    if (!acc[year]) {
      acc[year] = {
        quantity: 0,
        reconciliations: 0,
        partials: 0,
        pending: 0,
        percentage: 0,
      };
    }

    // 2. Agregamos el objeto específico del tipo (invoice, bill, expense)
    // Extraemos solo las propiedades que te interesan para el sub-objeto
    acc[year][curr.type] = {
      quantity: curr.quantity,
      reconciliations: curr.reconciliations,
      partials: curr.partials
    };

    // 3. Sumamos los valores a los totales del año
    acc[year].quantity += curr.quantity;
    acc[year].reconciliations += curr.reconciliations;
    acc[year].partials += curr.partials;

    acc[year].pending = acc[year].quantity - acc[year].reconciliations;
    acc[year].percentage = acc[year].quantity > 0 ? ((acc[year].reconciliations / acc[year].quantity) * 100).toFixed(1) + '%' : '0%';


    return acc;
  }, {});

  return transformedData;
}



export function formatDocumentData(data) {
  let formattedObject = {};

  // 1. Formatea la clave 'monthYear'
  // Asegura que el mes tenga 2 dígitos (ej. 6 -> '06')

  // 2. Convierte los valores de string a número
  const quantity = parseInt(data.quantity, 10);
  const reconciliations = parseInt(data.reconciliations, 10);
  const partials = parseInt(data.partials, 10);

  // 3. Calcula los valores de 'pending' y 'percentage'
  const pending = quantity - reconciliations;
  const percentage = quantity > 0 ? ((reconciliations / quantity) * 100).toFixed(1) + '%' : '0%';

  // 4. Asigna los valores al nuevo objeto
  formattedObject = {
    quantity,
    reconciliations,
    partials,
    pending,
    percentage,
  };


  return formattedObject;
}


</script>
